/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckPayment } from '../models/CheckPayment';
import type { CheckPaymentRequest } from '../models/CheckPaymentRequest';
import type { CreateCheatingReport } from '../models/CreateCheatingReport';
import type { CreateCheatingReportRequest } from '../models/CreateCheatingReportRequest';
import type { CreatePayment } from '../models/CreatePayment';
import type { CreatePaymentRequest } from '../models/CreatePaymentRequest';
import type { CreateTryout } from '../models/CreateTryout';
import type { CreateTryoutPlace } from '../models/CreateTryoutPlace';
import type { CreateTryoutPlaceRequest } from '../models/CreateTryoutPlaceRequest';
import type { CreateTryoutRequest } from '../models/CreateTryoutRequest';
import type { DetailUser } from '../models/DetailUser';
import type { EmailDuplicateRequest } from '../models/EmailDuplicateRequest';
import type { EmailDuplicateResponse } from '../models/EmailDuplicateResponse';
import type { FindPassword } from '../models/FindPassword';
import type { FindPasswordRequest } from '../models/FindPasswordRequest';
import type { LimitedUpdateTryout } from '../models/LimitedUpdateTryout';
import type { LimitedUpdateTryoutRequest } from '../models/LimitedUpdateTryoutRequest';
import type { ListApplicant } from '../models/ListApplicant';
import type { ListApplicantResult } from '../models/ListApplicantResult';
import type { ListClassification } from '../models/ListClassification';
import type { ListProgrammingLangauge } from '../models/ListProgrammingLangauge';
import type { ListRegulation } from '../models/ListRegulation';
import type { ListRule } from '../models/ListRule';
import type { LoginRequest } from '../models/LoginRequest';
import type { PaginatedListAdminApplicantResultList } from '../models/PaginatedListAdminApplicantResultList';
import type { PaginatedListTryoutApplicantList } from '../models/PaginatedListTryoutApplicantList';
import type { PaginatedListTryoutList } from '../models/PaginatedListTryoutList';
import type { PaginatedListTryoutPlaceList } from '../models/PaginatedListTryoutPlaceList';
import type { PaginatedV1AdminListApplicantList } from '../models/PaginatedV1AdminListApplicantList';
import type { PaginatedV1AdminListCheatingReportList } from '../models/PaginatedV1AdminListCheatingReportList';
import type { PaginatedV1AdminListClientAppList } from '../models/PaginatedV1AdminListClientAppList';
import type { PaginatedV1AdminListCouponApplicantList } from '../models/PaginatedV1AdminListCouponApplicantList';
import type { PaginatedV1AdminListEnterpriseUseCaseList } from '../models/PaginatedV1AdminListEnterpriseUseCaseList';
import type { PaginatedV1AdminListGroupTryoutCounselingList } from '../models/PaginatedV1AdminListGroupTryoutCounselingList';
import type { PaginatedV1AdminListJobList } from '../models/PaginatedV1AdminListJobList';
import type { PaginatedV1AdminListNoticeList } from '../models/PaginatedV1AdminListNoticeList';
import type { PaginatedV1AdminListOrganizationLandingPageList } from '../models/PaginatedV1AdminListOrganizationLandingPageList';
import type { PaginatedV1AdminListOrganizationList } from '../models/PaginatedV1AdminListOrganizationList';
import type { PaginatedV1AdminListOrganizationPaymentList } from '../models/PaginatedV1AdminListOrganizationPaymentList';
import type { PaginatedV1AdminListPressReleaseList } from '../models/PaginatedV1AdminListPressReleaseList';
import type { PaginatedV1AdminListSurveyList } from '../models/PaginatedV1AdminListSurveyList';
import type { PaginatedV1AdminListTryoutAppliesList } from '../models/PaginatedV1AdminListTryoutAppliesList';
import type { PaginatedV1AdminListTryoutCouponList } from '../models/PaginatedV1AdminListTryoutCouponList';
import type { PaginatedV1AdminListTryoutCouponPrivateSerialList } from '../models/PaginatedV1AdminListTryoutCouponPrivateSerialList';
import type { PaginatedV1AdminListUniversityUseCaseList } from '../models/PaginatedV1AdminListUniversityUseCaseList';
import type { PaginatedV1AdminListUserList } from '../models/PaginatedV1AdminListUserList';
import type { PaginatedV1AdminRemarksApplicantList } from '../models/PaginatedV1AdminRemarksApplicantList';
import type { PaginatedV1AdminTryoutCouponUserList } from '../models/PaginatedV1AdminTryoutCouponUserList';
import type { PaginatedV1ListEnterpriseUseCaseList } from '../models/PaginatedV1ListEnterpriseUseCaseList';
import type { PaginatedV1ListJobList } from '../models/PaginatedV1ListJobList';
import type { PaginatedV1ListNoticeList } from '../models/PaginatedV1ListNoticeList';
import type { PaginatedV1ListOrganizationApplicantList } from '../models/PaginatedV1ListOrganizationApplicantList';
import type { PaginatedV1ListOrganizationResultApplicantList } from '../models/PaginatedV1ListOrganizationResultApplicantList';
import type { PaginatedV1ListPressReleaseList } from '../models/PaginatedV1ListPressReleaseList';
import type { PaginatedV1ListProgrammersUserList } from '../models/PaginatedV1ListProgrammersUserList';
import type { PaginatedV1ListUniversityUseCaseList } from '../models/PaginatedV1ListUniversityUseCaseList';
import type { PaginatedV1LogosEnterpriseUseCaseList } from '../models/PaginatedV1LogosEnterpriseUseCaseList';
import type { PaginatedV1SalesManagementList } from '../models/PaginatedV1SalesManagementList';
import type { PartialUpdateApplicant } from '../models/PartialUpdateApplicant';
import type { PartialUpdateApplicantRequest } from '../models/PartialUpdateApplicantRequest';
import type { PatchedLimitedUpdateTryoutRequest } from '../models/PatchedLimitedUpdateTryoutRequest';
import type { PatchedPartialUpdateApplicantRequest } from '../models/PatchedPartialUpdateApplicantRequest';
import type { PatchedUpdateTryoutPlaceRequest } from '../models/PatchedUpdateTryoutPlaceRequest';
import type { PatchedUpdateTryoutRequest } from '../models/PatchedUpdateTryoutRequest';
import type { PatchedV1AdminCreateOrganizationOrganizationPriceRequest } from '../models/PatchedV1AdminCreateOrganizationOrganizationPriceRequest';
import type { PatchedV1AdminPostponementApplicantRequest } from '../models/PatchedV1AdminPostponementApplicantRequest';
import type { PatchedV1AdminRetrieveUpdateTryoutCouponRequest } from '../models/PatchedV1AdminRetrieveUpdateTryoutCouponRequest';
import type { PatchedV1AdminUpdateApplicantRemarksRequest } from '../models/PatchedV1AdminUpdateApplicantRemarksRequest';
import type { PatchedV1AdminUpdateBannerRequest } from '../models/PatchedV1AdminUpdateBannerRequest';
import type { PatchedV1AdminUpdateEnterpriseUseCaseRequest } from '../models/PatchedV1AdminUpdateEnterpriseUseCaseRequest';
import type { PatchedV1AdminUpdateJobRequest } from '../models/PatchedV1AdminUpdateJobRequest';
import type { PatchedV1AdminUpdateNoticeRequest } from '../models/PatchedV1AdminUpdateNoticeRequest';
import type { PatchedV1AdminUpdateOrganizationRequest } from '../models/PatchedV1AdminUpdateOrganizationRequest';
import type { PatchedV1AdminUpdatePressReleaseRequest } from '../models/PatchedV1AdminUpdatePressReleaseRequest';
import type { PatchedV1AdminUpdateSurveyRequest } from '../models/PatchedV1AdminUpdateSurveyRequest';
import type { PatchedV1AdminUpdateUniversityUseCaseRequest } from '../models/PatchedV1AdminUpdateUniversityUseCaseRequest';
import type { PatchedV1AdminWriteClientAppRequest } from '../models/PatchedV1AdminWriteClientAppRequest';
import type { PatchedV1AdminWriteOrganizationLandingPageRequest } from '../models/PatchedV1AdminWriteOrganizationLandingPageRequest';
import type { PatchedV1UpdateClientAppRequest } from '../models/PatchedV1UpdateClientAppRequest';
import type { PatchedV1UpdateOrganizationUserRequest } from '../models/PatchedV1UpdateOrganizationUserRequest';
import type { PatchedV1UpdateProgrammersTryoutRequest } from '../models/PatchedV1UpdateProgrammersTryoutRequest';
import type { PatchedV1UpdateProgrammersUserRequest } from '../models/PatchedV1UpdateProgrammersUserRequest';
import type { PatchedV1UpdateSalesManagementRequest } from '../models/PatchedV1UpdateSalesManagementRequest';
import type { PublishedListTryout } from '../models/PublishedListTryout';
import type { PublishedRetrieveTryout } from '../models/PublishedRetrieveTryout';
import type { ResetPasswordRequest } from '../models/ResetPasswordRequest';
import type { RetrieveApplicant } from '../models/RetrieveApplicant';
import type { RetrieveApplicantResult } from '../models/RetrieveApplicantResult';
import type { RetrieveTryout } from '../models/RetrieveTryout';
import type { RetrieveTryoutPlace } from '../models/RetrieveTryoutPlace';
import type { SignUpRequest } from '../models/SignUpRequest';
import type { ToggleUserMarketingAgreement } from '../models/ToggleUserMarketingAgreement';
import type { ToggleUserMarketingAgreementRequest } from '../models/ToggleUserMarketingAgreementRequest';
import type { UpdatePayment } from '../models/UpdatePayment';
import type { UpdatePaymentRequest } from '../models/UpdatePaymentRequest';
import type { UpdateTryout } from '../models/UpdateTryout';
import type { UpdateTryoutPlace } from '../models/UpdateTryoutPlace';
import type { UpdateTryoutPlaceRequest } from '../models/UpdateTryoutPlaceRequest';
import type { UpdateTryoutRequest } from '../models/UpdateTryoutRequest';
import type { V1AdminAllowReIdentification } from '../models/V1AdminAllowReIdentification';
import type { V1AdminApplicantsByClassificationStatistics } from '../models/V1AdminApplicantsByClassificationStatistics';
import type { V1AdminApprovalOrganizationPayment } from '../models/V1AdminApprovalOrganizationPayment';
import type { V1AdminBulkCreateTryoutCouponAssignmentRequest } from '../models/V1AdminBulkCreateTryoutCouponAssignmentRequest';
import type { V1AdminBulkCreateTryoutCouponPrivateSerialRequest } from '../models/V1AdminBulkCreateTryoutCouponPrivateSerialRequest';
import type { V1AdminBulkToggleEnterpriseUseCaseFix } from '../models/V1AdminBulkToggleEnterpriseUseCaseFix';
import type { V1AdminBulkToggleEnterpriseUseCaseFixRequest } from '../models/V1AdminBulkToggleEnterpriseUseCaseFixRequest';
import type { V1AdminBulkToggleNoticeFix } from '../models/V1AdminBulkToggleNoticeFix';
import type { V1AdminBulkToggleNoticeFixRequest } from '../models/V1AdminBulkToggleNoticeFixRequest';
import type { V1AdminBulkTogglePressReleaseFix } from '../models/V1AdminBulkTogglePressReleaseFix';
import type { V1AdminBulkTogglePressReleaseFixRequest } from '../models/V1AdminBulkTogglePressReleaseFixRequest';
import type { V1AdminBulkToggleUniversityUseCaseFix } from '../models/V1AdminBulkToggleUniversityUseCaseFix';
import type { V1AdminBulkToggleUniversityUseCaseFixRequest } from '../models/V1AdminBulkToggleUniversityUseCaseFixRequest';
import type { V1AdminBulkUpdateEnterpriseUseCaseOrders } from '../models/V1AdminBulkUpdateEnterpriseUseCaseOrders';
import type { V1AdminBulkUpdateEnterpriseUseCaseOrdersRequest } from '../models/V1AdminBulkUpdateEnterpriseUseCaseOrdersRequest';
import type { V1AdminBulkUpdateFixOrderJob } from '../models/V1AdminBulkUpdateFixOrderJob';
import type { V1AdminBulkUpdateFixOrderJobRequest } from '../models/V1AdminBulkUpdateFixOrderJobRequest';
import type { V1AdminBulkUpdateJob } from '../models/V1AdminBulkUpdateJob';
import type { V1AdminBulkUpdateJobRequest } from '../models/V1AdminBulkUpdateJobRequest';
import type { V1AdminBulkUpdateUniversityUseCaseOrders } from '../models/V1AdminBulkUpdateUniversityUseCaseOrders';
import type { V1AdminBulkUpdateUniversityUseCaseOrdersRequest } from '../models/V1AdminBulkUpdateUniversityUseCaseOrdersRequest';
import type { V1AdminBulkUpdateWithMainPageDisplayOrder } from '../models/V1AdminBulkUpdateWithMainPageDisplayOrder';
import type { V1AdminBulkUpdateWithMainPageDisplayOrderRequest } from '../models/V1AdminBulkUpdateWithMainPageDisplayOrderRequest';
import type { V1AdminCancelApplicant } from '../models/V1AdminCancelApplicant';
import type { V1AdminCancelApplicantRequest } from '../models/V1AdminCancelApplicantRequest';
import type { V1AdminCancelIdentityVerification } from '../models/V1AdminCancelIdentityVerification';
import type { V1AdminChallenges } from '../models/V1AdminChallenges';
import type { V1AdminClientAppAuthentication } from '../models/V1AdminClientAppAuthentication';
import type { V1AdminCreateBanner } from '../models/V1AdminCreateBanner';
import type { V1AdminCreateBannerRequest } from '../models/V1AdminCreateBannerRequest';
import type { V1AdminCreateEnterpriseUseCase } from '../models/V1AdminCreateEnterpriseUseCase';
import type { V1AdminCreateEnterpriseUseCaseRequest } from '../models/V1AdminCreateEnterpriseUseCaseRequest';
import type { V1AdminCreateJob } from '../models/V1AdminCreateJob';
import type { V1AdminCreateJobRequest } from '../models/V1AdminCreateJobRequest';
import type { V1AdminCreateNotice } from '../models/V1AdminCreateNotice';
import type { V1AdminCreateNoticeRequest } from '../models/V1AdminCreateNoticeRequest';
import type { V1AdminCreateOrganization } from '../models/V1AdminCreateOrganization';
import type { V1AdminCreateOrganizationOrganizationPrice } from '../models/V1AdminCreateOrganizationOrganizationPrice';
import type { V1AdminCreateOrganizationOrganizationPriceRequest } from '../models/V1AdminCreateOrganizationOrganizationPriceRequest';
import type { V1AdminCreateOrganizationRequest } from '../models/V1AdminCreateOrganizationRequest';
import type { V1AdminCreatePressRelease } from '../models/V1AdminCreatePressRelease';
import type { V1AdminCreatePressReleaseRequest } from '../models/V1AdminCreatePressReleaseRequest';
import type { V1AdminCreatePrivateSerialTryoutCoupon } from '../models/V1AdminCreatePrivateSerialTryoutCoupon';
import type { V1AdminCreatePrivateSerialTryoutCouponRequest } from '../models/V1AdminCreatePrivateSerialTryoutCouponRequest';
import type { V1AdminCreatePublicSerialTryoutCoupon } from '../models/V1AdminCreatePublicSerialTryoutCoupon';
import type { V1AdminCreatePublicSerialTryoutCouponRequest } from '../models/V1AdminCreatePublicSerialTryoutCouponRequest';
import type { V1AdminCreateSurvey } from '../models/V1AdminCreateSurvey';
import type { V1AdminCreateSurveyRequest } from '../models/V1AdminCreateSurveyRequest';
import type { V1AdminCreateUniversityUseCase } from '../models/V1AdminCreateUniversityUseCase';
import type { V1AdminCreateUniversityUseCaseRequest } from '../models/V1AdminCreateUniversityUseCaseRequest';
import type { V1AdminCreateUserTryoutCoupon } from '../models/V1AdminCreateUserTryoutCoupon';
import type { V1AdminCreateUserTryoutCouponRequest } from '../models/V1AdminCreateUserTryoutCouponRequest';
import type { V1AdminDaysSalesStatistics } from '../models/V1AdminDaysSalesStatistics';
import type { V1AdminForceCancelApplicant } from '../models/V1AdminForceCancelApplicant';
import type { V1AdminForceCancelApplicantRequest } from '../models/V1AdminForceCancelApplicantRequest';
import type { V1AdminListBanner } from '../models/V1AdminListBanner';
import type { V1AdminListFixedEnterpriseUseCase } from '../models/V1AdminListFixedEnterpriseUseCase';
import type { V1AdminListFixedNotice } from '../models/V1AdminListFixedNotice';
import type { V1AdminListFixedPressRelease } from '../models/V1AdminListFixedPressRelease';
import type { V1AdminListFixedUniversityUseCase } from '../models/V1AdminListFixedUniversityUseCase';
import type { V1AdminListJob } from '../models/V1AdminListJob';
import type { V1AdminListOrganizationOrganizationPrice } from '../models/V1AdminListOrganizationOrganizationPrice';
import type { V1AdminPeriodSalesStatistics } from '../models/V1AdminPeriodSalesStatistics';
import type { V1AdminPostponementApplicant } from '../models/V1AdminPostponementApplicant';
import type { V1AdminResponsesSurvey } from '../models/V1AdminResponsesSurvey';
import type { V1AdminRestrictionApplicant } from '../models/V1AdminRestrictionApplicant';
import type { V1AdminRestrictionApplicantRequest } from '../models/V1AdminRestrictionApplicantRequest';
import type { V1AdminRetrieveApplicant } from '../models/V1AdminRetrieveApplicant';
import type { V1AdminRetrieveApplicantRemarks } from '../models/V1AdminRetrieveApplicantRemarks';
import type { V1AdminRetrieveBanner } from '../models/V1AdminRetrieveBanner';
import type { V1AdminRetrieveCheatingReport } from '../models/V1AdminRetrieveCheatingReport';
import type { V1AdminRetrieveClientApp } from '../models/V1AdminRetrieveClientApp';
import type { V1AdminRetrieveEnterpriseUseCase } from '../models/V1AdminRetrieveEnterpriseUseCase';
import type { V1AdminRetrieveGroupTryoutCounseling } from '../models/V1AdminRetrieveGroupTryoutCounseling';
import type { V1AdminRetrieveJob } from '../models/V1AdminRetrieveJob';
import type { V1AdminRetrieveNotice } from '../models/V1AdminRetrieveNotice';
import type { V1AdminRetrieveOrganization } from '../models/V1AdminRetrieveOrganization';
import type { V1AdminRetrieveOrganizationLandingPage } from '../models/V1AdminRetrieveOrganizationLandingPage';
import type { V1AdminRetrieveOrganizationPayment } from '../models/V1AdminRetrieveOrganizationPayment';
import type { V1AdminRetrievePressRelease } from '../models/V1AdminRetrievePressRelease';
import type { V1AdminRetrieveSurvey } from '../models/V1AdminRetrieveSurvey';
import type { V1AdminRetrieveUniversityUseCase } from '../models/V1AdminRetrieveUniversityUseCase';
import type { V1AdminRetrieveUpdateTryoutCoupon } from '../models/V1AdminRetrieveUpdateTryoutCoupon';
import type { V1AdminSwitchBannerFixOrders } from '../models/V1AdminSwitchBannerFixOrders';
import type { V1AdminSwitchBannerFixOrdersRequest } from '../models/V1AdminSwitchBannerFixOrdersRequest';
import type { V1AdminTryoutCouponAssignment } from '../models/V1AdminTryoutCouponAssignment';
import type { V1AdminTryoutCouponNestedPrivateSerial } from '../models/V1AdminTryoutCouponNestedPrivateSerial';
import type { V1AdminTryoutCouponPrivateSerial } from '../models/V1AdminTryoutCouponPrivateSerial';
import type { V1AdminUpdateApplicantRemarks } from '../models/V1AdminUpdateApplicantRemarks';
import type { V1AdminUpdateApplicantRemarksRequest } from '../models/V1AdminUpdateApplicantRemarksRequest';
import type { V1AdminUpdateBanner } from '../models/V1AdminUpdateBanner';
import type { V1AdminUpdateBannerRequest } from '../models/V1AdminUpdateBannerRequest';
import type { V1AdminUpdateChallengesRequest } from '../models/V1AdminUpdateChallengesRequest';
import type { V1AdminUpdateEnterpriseUseCase } from '../models/V1AdminUpdateEnterpriseUseCase';
import type { V1AdminUpdateEnterpriseUseCaseRequest } from '../models/V1AdminUpdateEnterpriseUseCaseRequest';
import type { V1AdminUpdateJob } from '../models/V1AdminUpdateJob';
import type { V1AdminUpdateJobRequest } from '../models/V1AdminUpdateJobRequest';
import type { V1AdminUpdateNotice } from '../models/V1AdminUpdateNotice';
import type { V1AdminUpdateNoticeBulkUpdateOrders } from '../models/V1AdminUpdateNoticeBulkUpdateOrders';
import type { V1AdminUpdateNoticeBulkUpdateOrdersRequest } from '../models/V1AdminUpdateNoticeBulkUpdateOrdersRequest';
import type { V1AdminUpdateNoticeRequest } from '../models/V1AdminUpdateNoticeRequest';
import type { V1AdminUpdateOrganization } from '../models/V1AdminUpdateOrganization';
import type { V1AdminUpdateOrganizationRequest } from '../models/V1AdminUpdateOrganizationRequest';
import type { V1AdminUpdatePressRelease } from '../models/V1AdminUpdatePressRelease';
import type { V1AdminUpdatePressReleaseBulkUpdateOrders } from '../models/V1AdminUpdatePressReleaseBulkUpdateOrders';
import type { V1AdminUpdatePressReleaseBulkUpdateOrdersRequest } from '../models/V1AdminUpdatePressReleaseBulkUpdateOrdersRequest';
import type { V1AdminUpdatePressReleaseRequest } from '../models/V1AdminUpdatePressReleaseRequest';
import type { V1AdminUpdateSurvey } from '../models/V1AdminUpdateSurvey';
import type { V1AdminUpdateSurveyRequest } from '../models/V1AdminUpdateSurveyRequest';
import type { V1AdminUpdateUniversityUseCase } from '../models/V1AdminUpdateUniversityUseCase';
import type { V1AdminUpdateUniversityUseCaseRequest } from '../models/V1AdminUpdateUniversityUseCaseRequest';
import type { V1AdminWriteClientApp } from '../models/V1AdminWriteClientApp';
import type { V1AdminWriteClientAppRequest } from '../models/V1AdminWriteClientAppRequest';
import type { V1AdminWriteOrganizationLandingPage } from '../models/V1AdminWriteOrganizationLandingPage';
import type { V1AdminWriteOrganizationLandingPageRequest } from '../models/V1AdminWriteOrganizationLandingPageRequest';
import type { V1AppliesApplicant } from '../models/V1AppliesApplicant';
import type { V1Authenticate } from '../models/V1Authenticate';
import type { V1AuthenticationCallbackRequestRequest } from '../models/V1AuthenticationCallbackRequestRequest';
import type { V1AuthenticationRequestRequest } from '../models/V1AuthenticationRequestRequest';
import type { V1AuthenticityApplicantResults } from '../models/V1AuthenticityApplicantResults';
import type { V1AuthenticityApplicantResultsRequest } from '../models/V1AuthenticityApplicantResultsRequest';
import type { V1AuthenticityExcelApplicantResultRequest } from '../models/V1AuthenticityExcelApplicantResultRequest';
import type { V1BannerListTryout } from '../models/V1BannerListTryout';
import type { V1BulkCreateSurveyResponseRequest } from '../models/V1BulkCreateSurveyResponseRequest';
import type { V1CancelApplicant } from '../models/V1CancelApplicant';
import type { V1CancelApplicantRequest } from '../models/V1CancelApplicantRequest';
import type { V1CancelOrganizationPayment } from '../models/V1CancelOrganizationPayment';
import type { V1CancelOrganizationPaymentRequest } from '../models/V1CancelOrganizationPaymentRequest';
import type { V1ChangePasswordRequest } from '../models/V1ChangePasswordRequest';
import type { V1CompletionOrganizationPayment } from '../models/V1CompletionOrganizationPayment';
import type { V1CreateActionTracking } from '../models/V1CreateActionTracking';
import type { V1CreateActionTrackingRequest } from '../models/V1CreateActionTrackingRequest';
import type { V1CreateClientApp } from '../models/V1CreateClientApp';
import type { V1CreateClientAppAuthentication } from '../models/V1CreateClientAppAuthentication';
import type { V1CreateClientAppRequest } from '../models/V1CreateClientAppRequest';
import type { V1CreateGroupTryoutCounseling } from '../models/V1CreateGroupTryoutCounseling';
import type { V1CreateGroupTryoutCounselingRequest } from '../models/V1CreateGroupTryoutCounselingRequest';
import type { V1CreateOrganizationPayment } from '../models/V1CreateOrganizationPayment';
import type { V1CreateOrganizationPaymentRequest } from '../models/V1CreateOrganizationPaymentRequest';
import type { V1CreateSelectedCertificate } from '../models/V1CreateSelectedCertificate';
import type { V1CreateSelectedCertificateRequest } from '../models/V1CreateSelectedCertificateRequest';
import type { V1CreateTryoutCouponAssignment } from '../models/V1CreateTryoutCouponAssignment';
import type { V1CreateTryoutCouponAssignmentRequest } from '../models/V1CreateTryoutCouponAssignmentRequest';
import type { V1EntranceApplicantRequest } from '../models/V1EntranceApplicantRequest';
import type { V1FinishPreTestApplicantRequest } from '../models/V1FinishPreTestApplicantRequest';
import type { V1InfoPayment } from '../models/V1InfoPayment';
import type { V1LevelDistributions } from '../models/V1LevelDistributions';
import type { V1ListBanner } from '../models/V1ListBanner';
import type { V1ListCertificate } from '../models/V1ListCertificate';
import type { V1ListClientApp } from '../models/V1ListClientApp';
import type { V1ListClientAppAuthentication } from '../models/V1ListClientAppAuthentication';
import type { V1ListFixedNotice } from '../models/V1ListFixedNotice';
import type { V1ListFixedPressRelease } from '../models/V1ListFixedPressRelease';
import type { V1ListJob } from '../models/V1ListJob';
import type { V1ListOrganizationPayment } from '../models/V1ListOrganizationPayment';
import type { V1ListOrganizationPaymentApplicant } from '../models/V1ListOrganizationPaymentApplicant';
import type { V1ListOrganizationResultTryout } from '../models/V1ListOrganizationResultTryout';
import type { V1ListProgrammersCertificate } from '../models/V1ListProgrammersCertificate';
import type { V1ListSampleChallenge } from '../models/V1ListSampleChallenge';
import type { V1ListTryoutCouponAssignment } from '../models/V1ListTryoutCouponAssignment';
import type { V1OrganizationPaymentApplicantSerializers } from '../models/V1OrganizationPaymentApplicantSerializers';
import type { V1OrganizationPaymentApplicantSerializersRequest } from '../models/V1OrganizationPaymentApplicantSerializersRequest';
import type { V1OrganizationSignUpRequest } from '../models/V1OrganizationSignUpRequest';
import type { V1PartialCancelOrganizationPayment } from '../models/V1PartialCancelOrganizationPayment';
import type { V1PartialCancelOrganizationPaymentRequest } from '../models/V1PartialCancelOrganizationPaymentRequest';
import type { V1PCCEApplicantStatistic } from '../models/V1PCCEApplicantStatistic';
import type { V1PCCPApplicantStatistic } from '../models/V1PCCPApplicantStatistic';
import type { V1PCSQLApplicantStatistic } from '../models/V1PCSQLApplicantStatistic';
import type { V1PersonalizationListApplicant } from '../models/V1PersonalizationListApplicant';
import type { V1PreTestApplicant } from '../models/V1PreTestApplicant';
import type { V1RetrieveCertificate } from '../models/V1RetrieveCertificate';
import type { V1RetrieveClientApp } from '../models/V1RetrieveClientApp';
import type { V1RetrieveClientAppByAppId } from '../models/V1RetrieveClientAppByAppId';
import type { V1RetrieveJob } from '../models/V1RetrieveJob';
import type { V1RetrieveNotice } from '../models/V1RetrieveNotice';
import type { V1RetrieveOrganizationLandingPage } from '../models/V1RetrieveOrganizationLandingPage';
import type { V1RetrieveOrganizationPayment } from '../models/V1RetrieveOrganizationPayment';
import type { V1RetrieveOrganizationTryout } from '../models/V1RetrieveOrganizationTryout';
import type { V1RetrievePressRelease } from '../models/V1RetrievePressRelease';
import type { V1RetrieveSelectedCertificate } from '../models/V1RetrieveSelectedCertificate';
import type { V1RetrieveSurvey } from '../models/V1RetrieveSurvey';
import type { V1SalesManagement } from '../models/V1SalesManagement';
import type { V1SendEmailTryoutEmployeeVerification } from '../models/V1SendEmailTryoutEmployeeVerification';
import type { V1SendEmailTryoutEmployeeVerificationRequest } from '../models/V1SendEmailTryoutEmployeeVerificationRequest';
import type { V1ShareCertificate } from '../models/V1ShareCertificate';
import type { V1SharedCertificate } from '../models/V1SharedCertificate';
import type { V1UpdateClientApp } from '../models/V1UpdateClientApp';
import type { V1UpdateClientAppRequest } from '../models/V1UpdateClientAppRequest';
import type { V1UpdateOrganizationUser } from '../models/V1UpdateOrganizationUser';
import type { V1UpdateProgrammersTryout } from '../models/V1UpdateProgrammersTryout';
import type { V1UpdateProgrammersTryoutRequest } from '../models/V1UpdateProgrammersTryoutRequest';
import type { V1UpdateProgrammersUser } from '../models/V1UpdateProgrammersUser';
import type { V1UpdateProgrammersUserRequest } from '../models/V1UpdateProgrammersUserRequest';
import type { V1UpdateSalesManagement } from '../models/V1UpdateSalesManagement';
import type { V1UploadExcelOrganizationPaymentRequestRequest } from '../models/V1UploadExcelOrganizationPaymentRequestRequest';
import type { V1UploadExcelOrganizationPaymentResponse } from '../models/V1UploadExcelOrganizationPaymentResponse';
import type { V1VerifyTryoutEmployeeVerification } from '../models/V1VerifyTryoutEmployeeVerification';
import type { V1VerifyTryoutEmployeeVerificationRequest } from '../models/V1VerifyTryoutEmployeeVerificationRequest';
import type { ValidateResetPasswordToken } from '../models/ValidateResetPasswordToken';
import type { ValidateResetPasswordTokenRequest } from '../models/ValidateResetPasswordTokenRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class V1Service {

  /**
   * @returns PaginatedV1AdminListApplicantList
   * @throws ApiError
   */
  public static v1AdminApplicantsList({
    applicantStatus,
    languages,
    organization,
    organizationType,
    page,
    pageSize,
    paymentCouponAssignmentCouponId,
    paymentTryoutClassificationId,
    paymentTryoutStartAtGte,
    paymentTryoutStartAtLte,
    paymentTryoutType,
    paymentUserBirthdate,
    paymentUserEmail,
    paymentUserName,
    paymentUserPhoneContains,
    registrationEnd,
    registrationStart,
    tryoutCode,
  }: {
    /**
     * RE : 접수 완료 | CA : 접수 취소 | DO : 응시 완료 | NT : 미응시
     */
    applicantStatus?: 'CA' | 'DO' | 'NT' | 'RE',
    languages?: Array<number>,
    /**
     * 단체 ID
     */
    organization?: number,
    /**
     * ST : 특별 시험 | ER : 임직원 접수 | OR : 단체 접수
     */
    organizationType?: 'ER' | 'NO' | 'OR' | 'ST',
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    paymentCouponAssignmentCouponId?: number,
    paymentTryoutClassificationId?: number,
    paymentTryoutStartAtGte?: string,
    paymentTryoutStartAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    paymentTryoutType?: 'OC' | 'RE' | 'SP',
    paymentUserBirthdate?: string,
    paymentUserEmail?: string,
    paymentUserName?: string,
    paymentUserPhoneContains?: string,
    registrationEnd?: string,
    registrationStart?: string,
    tryoutCode?: string,
  }): CancelablePromise<PaginatedV1AdminListApplicantList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/applicants/',
      query: {
        'applicant_status': applicantStatus,
        'languages': languages,
        'organization': organization,
        'organization_type': organizationType,
        'page': page,
        'page_size': pageSize,
        'payment__coupon_assignment__coupon__id': paymentCouponAssignmentCouponId,
        'payment__tryout__classification__id': paymentTryoutClassificationId,
        'payment__tryout__start_at__gte': paymentTryoutStartAtGte,
        'payment__tryout__start_at__lte': paymentTryoutStartAtLte,
        'payment__tryout__type': paymentTryoutType,
        'payment__user__birthdate': paymentUserBirthdate,
        'payment__user__email': paymentUserEmail,
        'payment__user__name': paymentUserName,
        'payment__user__phone__contains': paymentUserPhoneContains,
        'registration_end': registrationEnd,
        'registration_start': registrationStart,
        'tryout_code': tryoutCode,
      },
    });
  }

  /**
   * @returns V1AdminRetrieveApplicant
   * @throws ApiError
   */
  public static v1AdminApplicantsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 응시자.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveApplicant> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/applicants/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns PartialUpdateApplicant
   * @throws ApiError
   */
  public static v1AdminApplicantsUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 응시자.
     */
    id: number,
    requestBody: PartialUpdateApplicantRequest,
  }): CancelablePromise<PartialUpdateApplicant> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/applicants/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PartialUpdateApplicant
   * @throws ApiError
   */
  public static v1AdminApplicantsPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 응시자.
     */
    id: number,
    requestBody?: PatchedPartialUpdateApplicantRequest,
  }): CancelablePromise<PartialUpdateApplicant> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/applicants/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminCancelApplicant
   * @throws ApiError
   */
  public static v1AdminApplicantsCancelCreate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 응시자.
     */
    id: number,
    requestBody: V1AdminCancelApplicantRequest,
  }): CancelablePromise<V1AdminCancelApplicant> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/applicants/{id}/cancel/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminForceCancelApplicant
   * @throws ApiError
   */
  public static v1AdminApplicantsForceCancelCreate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 응시자.
     */
    id: number,
    requestBody: V1AdminForceCancelApplicantRequest,
  }): CancelablePromise<V1AdminForceCancelApplicant> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/applicants/{id}/force-cancel/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminPostponementApplicant
   * @throws ApiError
   */
  public static v1AdminApplicantsPostponementPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 응시자.
     */
    id: number,
    requestBody?: PatchedV1AdminPostponementApplicantRequest,
  }): CancelablePromise<V1AdminPostponementApplicant> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/applicants/{id}/postponement/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminRestrictionApplicant
   * @throws ApiError
   */
  public static v1AdminApplicantsRestrictionCreate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 응시자.
     */
    id: number,
    requestBody: V1AdminRestrictionApplicantRequest,
  }): CancelablePromise<V1AdminRestrictionApplicant> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/applicants/{id}/restriction/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminApplicantsResultDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 응시자.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/applicants/{id}/result/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminRetrieveApplicantRemarks
   * @throws ApiError
   */
  public static v1AdminApplicantsApplicantRemarksRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 응시자 특이사항.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveApplicantRemarks> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/applicants/applicant-remarks/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminUpdateApplicantRemarks
   * @throws ApiError
   */
  public static v1AdminApplicantsApplicantRemarksUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 응시자 특이사항.
     */
    id: number,
    requestBody?: V1AdminUpdateApplicantRemarksRequest,
  }): CancelablePromise<V1AdminUpdateApplicantRemarks> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/applicants/applicant-remarks/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminUpdateApplicantRemarks
   * @throws ApiError
   */
  public static v1AdminApplicantsApplicantRemarksPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 응시자 특이사항.
     */
    id: number,
    requestBody?: PatchedV1AdminUpdateApplicantRemarksRequest,
  }): CancelablePromise<V1AdminUpdateApplicantRemarks> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/applicants/applicant-remarks/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedListAdminApplicantResultList
   * @throws ApiError
   */
  public static v1AdminApplicantsApplicantResultsList({
    applicantPaymentCouponAssignmentCoupon,
    applicantPaymentTryoutClassificationId,
    applicantPaymentTryoutSite,
    applicantPaymentTryoutStartAtGte,
    applicantPaymentTryoutStartAtLte,
    applicantPaymentTryoutType,
    applicantPaymentUserBirthdate,
    applicantPaymentUserEmail,
    applicantPaymentUserEmailContains,
    applicantPaymentUserName,
    applicantPaymentUserNameContains,
    applicantTryoutCode,
    organization,
    page,
    pageSize,
  }: {
    applicantPaymentCouponAssignmentCoupon?: number,
    applicantPaymentTryoutClassificationId?: number,
    /**
     * MONITO : MO | OFFLINE : OF
     */
    applicantPaymentTryoutSite?: 'MO' | 'OF',
    applicantPaymentTryoutStartAtGte?: string,
    applicantPaymentTryoutStartAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    applicantPaymentTryoutType?: 'OC' | 'RE' | 'SP',
    applicantPaymentUserBirthdate?: string,
    applicantPaymentUserEmail?: string,
    applicantPaymentUserEmailContains?: string,
    applicantPaymentUserName?: string,
    applicantPaymentUserNameContains?: string,
    applicantTryoutCode?: string,
    /**
     * 단체 ID 값을 입력하세요.
     */
    organization?: number,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedListAdminApplicantResultList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/applicants/applicant-results/',
      query: {
        'applicant__payment__coupon_assignment__coupon': applicantPaymentCouponAssignmentCoupon,
        'applicant__payment__tryout__classification__id': applicantPaymentTryoutClassificationId,
        'applicant__payment__tryout__site': applicantPaymentTryoutSite,
        'applicant__payment__tryout__start_at__gte': applicantPaymentTryoutStartAtGte,
        'applicant__payment__tryout__start_at__lte': applicantPaymentTryoutStartAtLte,
        'applicant__payment__tryout__type': applicantPaymentTryoutType,
        'applicant__payment__user__birthdate': applicantPaymentUserBirthdate,
        'applicant__payment__user__email': applicantPaymentUserEmail,
        'applicant__payment__user__email__contains': applicantPaymentUserEmailContains,
        'applicant__payment__user__name': applicantPaymentUserName,
        'applicant__payment__user__name__contains': applicantPaymentUserNameContains,
        'applicant__tryout_code': applicantTryoutCode,
        'organization': organization,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1AdminApplicantsApplicantResultsExcelRetrieve({
    applicantPaymentCouponAssignmentCoupon,
    applicantPaymentTryoutClassificationId,
    applicantPaymentTryoutSite,
    applicantPaymentTryoutStartAtGte,
    applicantPaymentTryoutStartAtLte,
    applicantPaymentTryoutType,
    applicantPaymentUserBirthdate,
    applicantPaymentUserEmail,
    applicantPaymentUserEmailContains,
    applicantPaymentUserName,
    applicantPaymentUserNameContains,
    applicantTryoutCode,
    organization,
  }: {
    applicantPaymentCouponAssignmentCoupon?: number,
    applicantPaymentTryoutClassificationId?: number,
    /**
     * MONITO : MO | OFFLINE : OF
     */
    applicantPaymentTryoutSite?: 'MO' | 'OF',
    applicantPaymentTryoutStartAtGte?: string,
    applicantPaymentTryoutStartAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    applicantPaymentTryoutType?: 'OC' | 'RE' | 'SP',
    applicantPaymentUserBirthdate?: string,
    applicantPaymentUserEmail?: string,
    applicantPaymentUserEmailContains?: string,
    applicantPaymentUserName?: string,
    applicantPaymentUserNameContains?: string,
    applicantTryoutCode?: string,
    /**
     * 단체 ID 값을 입력하세요.
     */
    organization?: number,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/applicants/applicant-results/excel/',
      query: {
        'applicant__payment__coupon_assignment__coupon': applicantPaymentCouponAssignmentCoupon,
        'applicant__payment__tryout__classification__id': applicantPaymentTryoutClassificationId,
        'applicant__payment__tryout__site': applicantPaymentTryoutSite,
        'applicant__payment__tryout__start_at__gte': applicantPaymentTryoutStartAtGte,
        'applicant__payment__tryout__start_at__lte': applicantPaymentTryoutStartAtLte,
        'applicant__payment__tryout__type': applicantPaymentTryoutType,
        'applicant__payment__user__birthdate': applicantPaymentUserBirthdate,
        'applicant__payment__user__email': applicantPaymentUserEmail,
        'applicant__payment__user__email__contains': applicantPaymentUserEmailContains,
        'applicant__payment__user__name': applicantPaymentUserName,
        'applicant__payment__user__name__contains': applicantPaymentUserNameContains,
        'applicant__tryout_code': applicantTryoutCode,
        'organization': organization,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListCouponApplicantList
   * @throws ApiError
   */
  public static v1AdminApplicantsCouponsList({
    page,
    pageSize,
    paymentCouponAssignmentCoupon,
    paymentTryoutClassification,
    paymentTryoutOrganization,
    paymentUserBirthdateIcontains,
    paymentUserEmailIcontains,
    paymentUserNameIcontains,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    paymentCouponAssignmentCoupon?: number,
    paymentTryoutClassification?: number,
    paymentTryoutOrganization?: number,
    paymentUserBirthdateIcontains?: string,
    paymentUserEmailIcontains?: string,
    paymentUserNameIcontains?: string,
  }): CancelablePromise<PaginatedV1AdminListCouponApplicantList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/applicants/coupons/',
      query: {
        'page': page,
        'page_size': pageSize,
        'payment__coupon_assignment__coupon': paymentCouponAssignmentCoupon,
        'payment__tryout__classification': paymentTryoutClassification,
        'payment__tryout__organization': paymentTryoutOrganization,
        'payment__user__birthdate__icontains': paymentUserBirthdateIcontains,
        'payment__user__email__icontains': paymentUserEmailIcontains,
        'payment__user__name__icontains': paymentUserNameIcontains,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1AdminApplicantsExcelRetrieve({
    applicantStatus,
    languages,
    organization,
    organizationType,
    paymentCouponAssignmentCouponId,
    paymentTryoutClassificationId,
    paymentTryoutStartAtGte,
    paymentTryoutStartAtLte,
    paymentTryoutType,
    paymentUserBirthdate,
    paymentUserEmail,
    paymentUserName,
    paymentUserPhoneContains,
    registrationEnd,
    registrationStart,
    tryoutCode,
  }: {
    /**
     * RE : 접수 완료 | CA : 접수 취소 | DO : 응시 완료 | NT : 미응시
     */
    applicantStatus?: 'CA' | 'DO' | 'NT' | 'RE',
    languages?: Array<number>,
    /**
     * 단체 ID
     */
    organization?: number,
    /**
     * ST : 특별 시험 | ER : 임직원 접수 | OR : 단체 접수
     */
    organizationType?: 'ER' | 'NO' | 'OR' | 'ST',
    paymentCouponAssignmentCouponId?: number,
    paymentTryoutClassificationId?: number,
    paymentTryoutStartAtGte?: string,
    paymentTryoutStartAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    paymentTryoutType?: 'OC' | 'RE' | 'SP',
    paymentUserBirthdate?: string,
    paymentUserEmail?: string,
    paymentUserName?: string,
    paymentUserPhoneContains?: string,
    registrationEnd?: string,
    registrationStart?: string,
    tryoutCode?: string,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/applicants/excel/',
      query: {
        'applicant_status': applicantStatus,
        'languages': languages,
        'organization': organization,
        'organization_type': organizationType,
        'payment__coupon_assignment__coupon__id': paymentCouponAssignmentCouponId,
        'payment__tryout__classification__id': paymentTryoutClassificationId,
        'payment__tryout__start_at__gte': paymentTryoutStartAtGte,
        'payment__tryout__start_at__lte': paymentTryoutStartAtLte,
        'payment__tryout__type': paymentTryoutType,
        'payment__user__birthdate': paymentUserBirthdate,
        'payment__user__email': paymentUserEmail,
        'payment__user__name': paymentUserName,
        'payment__user__phone__contains': paymentUserPhoneContains,
        'registration_end': registrationEnd,
        'registration_start': registrationStart,
        'tryout_code': tryoutCode,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListApplicantList
   * @throws ApiError
   */
  public static v1AdminApplicantsOrganizationsList({
    applicantStatus,
    languages,
    organization,
    organizationType,
    page,
    pageSize,
    paymentCouponAssignmentCouponId,
    paymentTryoutClassificationId,
    paymentTryoutStartAtGte,
    paymentTryoutStartAtLte,
    paymentTryoutType,
    paymentUserBirthdate,
    paymentUserEmail,
    paymentUserName,
    paymentUserPhoneContains,
    registrationEnd,
    registrationStart,
    tryoutCode,
  }: {
    /**
     * RE : 접수 완료 | CA : 접수 취소 | DO : 응시 완료 | NT : 미응시
     */
    applicantStatus?: 'CA' | 'DO' | 'NT' | 'RE',
    languages?: Array<number>,
    /**
     * 단체 ID
     */
    organization?: number,
    /**
     * ST : 특별 시험 | ER : 임직원 접수 | OR : 단체 접수
     */
    organizationType?: 'ER' | 'NO' | 'OR' | 'ST',
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    paymentCouponAssignmentCouponId?: number,
    paymentTryoutClassificationId?: number,
    paymentTryoutStartAtGte?: string,
    paymentTryoutStartAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    paymentTryoutType?: 'OC' | 'RE' | 'SP',
    paymentUserBirthdate?: string,
    paymentUserEmail?: string,
    paymentUserName?: string,
    paymentUserPhoneContains?: string,
    registrationEnd?: string,
    registrationStart?: string,
    tryoutCode?: string,
  }): CancelablePromise<PaginatedV1AdminListApplicantList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/applicants/organizations/',
      query: {
        'applicant_status': applicantStatus,
        'languages': languages,
        'organization': organization,
        'organization_type': organizationType,
        'page': page,
        'page_size': pageSize,
        'payment__coupon_assignment__coupon__id': paymentCouponAssignmentCouponId,
        'payment__tryout__classification__id': paymentTryoutClassificationId,
        'payment__tryout__start_at__gte': paymentTryoutStartAtGte,
        'payment__tryout__start_at__lte': paymentTryoutStartAtLte,
        'payment__tryout__type': paymentTryoutType,
        'payment__user__birthdate': paymentUserBirthdate,
        'payment__user__email': paymentUserEmail,
        'payment__user__name': paymentUserName,
        'payment__user__phone__contains': paymentUserPhoneContains,
        'registration_end': registrationEnd,
        'registration_start': registrationStart,
        'tryout_code': tryoutCode,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminRemarksApplicantList
   * @throws ApiError
   */
  public static v1AdminApplicantsRemarksList({
    language,
    organization,
    page,
    pageSize,
    paymentTryoutClassificationId,
    paymentTryoutSite,
    paymentTryoutStartAtGte,
    paymentTryoutStartAtLte,
    paymentTryoutType,
    remarksType,
  }: {
    language?: Array<number>,
    organization?: number,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    paymentTryoutClassificationId?: number,
    /**
     * MONITO : MO | OFFLINE : OF
     */
    paymentTryoutSite?: 'MO' | 'OF',
    paymentTryoutStartAtGte?: string,
    paymentTryoutStartAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    paymentTryoutType?: 'OC' | 'RE' | 'SP',
    /**
     * CH : 부정행위 | AB : 결시 | VI : 규정위반 | AC : 사고사유
     */
    remarksType?: Array<'AB' | 'AC' | 'CH' | 'VI'>,
  }): CancelablePromise<PaginatedV1AdminRemarksApplicantList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/applicants/remarks/',
      query: {
        'language': language,
        'organization': organization,
        'page': page,
        'page_size': pageSize,
        'payment__tryout__classification__id': paymentTryoutClassificationId,
        'payment__tryout__site': paymentTryoutSite,
        'payment__tryout__start_at__gte': paymentTryoutStartAtGte,
        'payment__tryout__start_at__lte': paymentTryoutStartAtLte,
        'payment__tryout__type': paymentTryoutType,
        'remarks_type': remarksType,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListClientAppList
   * @throws ApiError
   */
  public static v1AdminAuthorizationsClientAppsList({
    page,
    pageSize,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListClientAppList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/authorizations/client-apps/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminWriteClientApp
   * @throws ApiError
   */
  public static v1AdminAuthorizationsClientAppsCreate({
    requestBody,
  }: {
    requestBody: V1AdminWriteClientAppRequest,
  }): CancelablePromise<V1AdminWriteClientApp> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/authorizations/client-apps/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminClientAppAuthentication
   * @throws ApiError
   */
  public static v1AdminAuthorizationsClientAppsAuthenticationsList({
    clientAppPk,
  }: {
    clientAppPk: number,
  }): CancelablePromise<Array<V1AdminClientAppAuthentication>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/authorizations/client-apps/{client_app_pk}/authentications/',
      path: {
        'client_app_pk': clientAppPk,
      },
    });
  }

  /**
   * @returns V1AdminClientAppAuthentication
   * @throws ApiError
   */
  public static v1AdminAuthorizationsClientAppsAuthenticationsCreate({
    clientAppPk,
  }: {
    clientAppPk: number,
  }): CancelablePromise<V1AdminClientAppAuthentication> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/authorizations/client-apps/{client_app_pk}/authentications/',
      path: {
        'client_app_pk': clientAppPk,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminAuthorizationsClientAppsAuthenticationsDestroy({
    clientAppPk,
    id,
  }: {
    clientAppPk: number,
    /**
     * A unique integer value identifying this 클라이언트 앱 인증.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/authorizations/client-apps/{client_app_pk}/authentications/{id}/',
      path: {
        'client_app_pk': clientAppPk,
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminRetrieveClientApp
   * @throws ApiError
   */
  public static v1AdminAuthorizationsClientAppsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 클라이언트 앱.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveClientApp> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/authorizations/client-apps/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminWriteClientApp
   * @throws ApiError
   */
  public static v1AdminAuthorizationsClientAppsUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 클라이언트 앱.
     */
    id: number,
    requestBody: V1AdminWriteClientAppRequest,
  }): CancelablePromise<V1AdminWriteClientApp> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/authorizations/client-apps/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminWriteClientApp
   * @throws ApiError
   */
  public static v1AdminAuthorizationsClientAppsPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 클라이언트 앱.
     */
    id: number,
    requestBody?: PatchedV1AdminWriteClientAppRequest,
  }): CancelablePromise<V1AdminWriteClientApp> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/authorizations/client-apps/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminAuthorizationsClientAppsDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 클라이언트 앱.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/authorizations/client-apps/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminListBanner
   * @throws ApiError
   */
  public static v1AdminBannersList(): CancelablePromise<Array<V1AdminListBanner>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/banners/',
    });
  }

  /**
   * @returns V1AdminCreateBanner
   * @throws ApiError
   */
  public static v1AdminBannersCreate({
    formData,
  }: {
    formData: V1AdminCreateBannerRequest,
  }): CancelablePromise<V1AdminCreateBanner> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/banners/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminRetrieveBanner
   * @throws ApiError
   */
  public static v1AdminBannersRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 배너.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveBanner> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/banners/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminUpdateBanner
   * @throws ApiError
   */
  public static v1AdminBannersUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 배너.
     */
    id: number,
    formData: V1AdminUpdateBannerRequest,
  }): CancelablePromise<V1AdminUpdateBanner> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/banners/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminUpdateBanner
   * @throws ApiError
   */
  public static v1AdminBannersPartialUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 배너.
     */
    id: number,
    formData?: PatchedV1AdminUpdateBannerRequest,
  }): CancelablePromise<V1AdminUpdateBanner> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/banners/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminBannersDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 배너.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/banners/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminSwitchBannerFixOrders
   * @throws ApiError
   */
  public static v1AdminBannersSwitchFixOrdersCreate({
    requestBody,
  }: {
    requestBody: V1AdminSwitchBannerFixOrdersRequest,
  }): CancelablePromise<V1AdminSwitchBannerFixOrders> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/banners/switch-fix-orders/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1AdminListCheatingReportList
   * @throws ApiError
   */
  public static v1AdminCheatingReportsList({
    page,
    pageSize,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListCheatingReportList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/cheating-reports/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminRetrieveCheatingReport
   * @throws ApiError
   */
  public static v1AdminCheatingReportsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 부정 행위 신고.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveCheatingReport> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/cheating-reports/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListTryoutCouponPrivateSerialList
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponPrivateSerialsList({
    page,
    pageSize,
    serial,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    serial?: string,
  }): CancelablePromise<PaginatedV1AdminListTryoutCouponPrivateSerialList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/coupons/tryout-coupon-private-serials/',
      query: {
        'page': page,
        'page_size': pageSize,
        'serial': serial,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponPrivateSerialsDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 비공개 시리얼.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/coupons/tryout-coupon-private-serials/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminTryoutCouponPrivateSerial
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponPrivateSerialsBulkCreateCreate({
    requestBody,
    serial,
  }: {
    requestBody: V1AdminBulkCreateTryoutCouponPrivateSerialRequest,
    serial?: string,
  }): CancelablePromise<Array<V1AdminTryoutCouponPrivateSerial>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/coupons/tryout-coupon-private-serials/bulk-create/',
      query: {
        'serial': serial,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1AdminListTryoutCouponList
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsList({
    classification,
    end,
    issueAtEnd,
    issueAtStart,
    page,
    pageSize,
    start,
    tryoutCouponType,
  }: {
    classification?: number,
    /**
     * 유효기간 조회 종료 시간
     */
    end?: string,
    issueAtEnd?: string,
    issueAtStart?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    /**
     * 유효기간 조회 시작 시간
     */
    start?: string,
    /**
     * PRS : 비공개 시리얼 번호 발급 | PUS : 공개 시리얼 번호 발급 | USE : 대상자 지정 발급
     */
    tryoutCouponType?: 'PRS' | 'PUS' | 'USE',
  }): CancelablePromise<PaginatedV1AdminListTryoutCouponList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/coupons/tryout-coupons/',
      query: {
        'classification': classification,
        'end': end,
        'issue_at_end': issueAtEnd,
        'issue_at_start': issueAtStart,
        'page': page,
        'page_size': pageSize,
        'start': start,
        'tryout_coupon_type': tryoutCouponType,
      },
    });
  }

  /**
   * @returns V1AdminTryoutCouponAssignment
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsTryoutCouponAssignmentsList({
    couponPk,
  }: {
    couponPk: number,
  }): CancelablePromise<Array<V1AdminTryoutCouponAssignment>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/coupons/tryout-coupons/{coupon_pk}/tryout-coupon-assignments/',
      path: {
        'coupon_pk': couponPk,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsTryoutCouponAssignmentsDestroy({
    couponPk,
    id,
  }: {
    couponPk: number,
    /**
     * A unique integer value identifying this 시험 쿠폰 할당.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/coupons/tryout-coupons/{coupon_pk}/tryout-coupon-assignments/{id}/',
      path: {
        'coupon_pk': couponPk,
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminTryoutCouponAssignment
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsTryoutCouponAssignmentsBulkCreateCreate({
    couponPk,
    requestBody,
  }: {
    couponPk: number,
    requestBody: V1AdminBulkCreateTryoutCouponAssignmentRequest,
  }): CancelablePromise<Array<V1AdminTryoutCouponAssignment>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/coupons/tryout-coupons/{coupon_pk}/tryout-coupon-assignments/bulk-create/',
      path: {
        'coupon_pk': couponPk,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminTryoutCouponNestedPrivateSerial
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsTryoutCouponPrivateSerialsList({
    couponPk,
  }: {
    couponPk: number,
  }): CancelablePromise<Array<V1AdminTryoutCouponNestedPrivateSerial>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/coupons/tryout-coupons/{coupon_pk}/tryout-coupon-private-serials/',
      path: {
        'coupon_pk': couponPk,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsTryoutCouponPrivateSerialsDestroy({
    couponPk,
    id,
  }: {
    couponPk: number,
    /**
     * A unique integer value identifying this 비공개 시리얼.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/coupons/tryout-coupons/{coupon_pk}/tryout-coupon-private-serials/{id}/',
      path: {
        'coupon_pk': couponPk,
        'id': id,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsTryoutCouponPrivateSerialsDownloadExcelRetrieve({
    couponPk,
  }: {
    couponPk: number,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/coupons/tryout-coupons/{coupon_pk}/tryout-coupon-private-serials/download-excel/',
      path: {
        'coupon_pk': couponPk,
      },
    });
  }

  /**
   * @returns V1AdminRetrieveUpdateTryoutCoupon
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 쿠폰.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveUpdateTryoutCoupon> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/coupons/tryout-coupons/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminRetrieveUpdateTryoutCoupon
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 쿠폰.
     */
    id: number,
    requestBody?: PatchedV1AdminRetrieveUpdateTryoutCouponRequest,
  }): CancelablePromise<V1AdminRetrieveUpdateTryoutCoupon> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/coupons/tryout-coupons/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 쿠폰.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/coupons/tryout-coupons/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminCreatePrivateSerialTryoutCoupon
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsPrivateSerialsCreate({
    requestBody,
  }: {
    requestBody: V1AdminCreatePrivateSerialTryoutCouponRequest,
  }): CancelablePromise<V1AdminCreatePrivateSerialTryoutCoupon> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/coupons/tryout-coupons/private-serials/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminCreatePublicSerialTryoutCoupon
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsPublicSerialsCreate({
    requestBody,
  }: {
    requestBody: V1AdminCreatePublicSerialTryoutCouponRequest,
  }): CancelablePromise<V1AdminCreatePublicSerialTryoutCoupon> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/coupons/tryout-coupons/public-serials/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminCreateUserTryoutCoupon
   * @throws ApiError
   */
  public static v1AdminCouponsTryoutCouponsUsersCreate({
    requestBody,
  }: {
    requestBody: V1AdminCreateUserTryoutCouponRequest,
  }): CancelablePromise<V1AdminCreateUserTryoutCoupon> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/coupons/tryout-coupons/users/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1AdminTryoutCouponUserList
   * @throws ApiError
   */
  public static v1AdminCouponsUsersList({
    email,
    name,
    page,
    pageSize,
  }: {
    email?: string,
    name?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminTryoutCouponUserList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/coupons/users/',
      query: {
        'email': email,
        'name': name,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListEnterpriseUseCaseList
   * @throws ApiError
   */
  public static v1AdminEnterpriseUseCasesList({
    page,
    pageSize,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListEnterpriseUseCaseList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/enterprise-use-cases/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminCreateEnterpriseUseCase
   * @throws ApiError
   */
  public static v1AdminEnterpriseUseCasesCreate({
    formData,
  }: {
    formData: V1AdminCreateEnterpriseUseCaseRequest,
  }): CancelablePromise<V1AdminCreateEnterpriseUseCase> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/enterprise-use-cases/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminRetrieveEnterpriseUseCase
   * @throws ApiError
   */
  public static v1AdminEnterpriseUseCasesRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 기업 활용 사례.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveEnterpriseUseCase> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/enterprise-use-cases/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminUpdateEnterpriseUseCase
   * @throws ApiError
   */
  public static v1AdminEnterpriseUseCasesUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 기업 활용 사례.
     */
    id: number,
    formData: V1AdminUpdateEnterpriseUseCaseRequest,
  }): CancelablePromise<V1AdminUpdateEnterpriseUseCase> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/enterprise-use-cases/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminUpdateEnterpriseUseCase
   * @throws ApiError
   */
  public static v1AdminEnterpriseUseCasesPartialUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 기업 활용 사례.
     */
    id: number,
    formData?: PatchedV1AdminUpdateEnterpriseUseCaseRequest,
  }): CancelablePromise<V1AdminUpdateEnterpriseUseCase> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/enterprise-use-cases/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminEnterpriseUseCasesDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 기업 활용 사례.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/enterprise-use-cases/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminBulkToggleEnterpriseUseCaseFix
   * @throws ApiError
   */
  public static v1AdminEnterpriseUseCasesBulkToggleFixCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminBulkToggleEnterpriseUseCaseFixRequest>,
  }): CancelablePromise<Array<V1AdminBulkToggleEnterpriseUseCaseFix>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/enterprise-use-cases/bulk-toggle-fix/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminBulkUpdateEnterpriseUseCaseOrders
   * @throws ApiError
   */
  public static v1AdminEnterpriseUseCasesBulkUpdateOrdersCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminBulkUpdateEnterpriseUseCaseOrdersRequest>,
  }): CancelablePromise<Array<V1AdminBulkUpdateEnterpriseUseCaseOrders>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/enterprise-use-cases/bulk-update-orders/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminListFixedEnterpriseUseCase
   * @throws ApiError
   */
  public static v1AdminEnterpriseUseCasesFixedList(): CancelablePromise<Array<V1AdminListFixedEnterpriseUseCase>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/enterprise-use-cases/fixed/',
    });
  }

  /**
   * @returns PaginatedV1AdminListGroupTryoutCounselingList
   * @throws ApiError
   */
  public static v1AdminGroupTryoutCounselingsList({
    groupNameIcontains,
    manager,
    page,
    pageSize,
  }: {
    groupNameIcontains?: string,
    manager?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListGroupTryoutCounselingList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/group-tryout-counselings/',
      query: {
        'group_name__icontains': groupNameIcontains,
        'manager': manager,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminRetrieveGroupTryoutCounseling
   * @throws ApiError
   */
  public static v1AdminGroupTryoutCounselingsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 단체 시험 상담.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveGroupTryoutCounseling> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/group-tryout-counselings/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListJobList
   * @throws ApiError
   */
  public static v1AdminJobsList({
    page,
    pageSize,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListJobList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/jobs/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminCreateJob
   * @throws ApiError
   */
  public static v1AdminJobsCreate({
    formData,
  }: {
    formData: V1AdminCreateJobRequest,
  }): CancelablePromise<V1AdminCreateJob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/jobs/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminRetrieveJob
   * @throws ApiError
   */
  public static v1AdminJobsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 채용 정보.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveJob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/jobs/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminUpdateJob
   * @throws ApiError
   */
  public static v1AdminJobsUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 채용 정보.
     */
    id: number,
    formData: V1AdminUpdateJobRequest,
  }): CancelablePromise<V1AdminUpdateJob> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/jobs/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminUpdateJob
   * @throws ApiError
   */
  public static v1AdminJobsPartialUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 채용 정보.
     */
    id: number,
    formData?: PatchedV1AdminUpdateJobRequest,
  }): CancelablePromise<V1AdminUpdateJob> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/jobs/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminJobsDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 채용 정보.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/jobs/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminBulkUpdateJob
   * @throws ApiError
   */
  public static v1AdminJobsBulkUpdateCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminBulkUpdateJobRequest>,
  }): CancelablePromise<Array<V1AdminBulkUpdateJob>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/jobs/bulk-update/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminBulkUpdateFixOrderJob
   * @throws ApiError
   */
  public static v1AdminJobsBulkUpdateFixOrderCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminBulkUpdateFixOrderJobRequest>,
  }): CancelablePromise<Array<V1AdminBulkUpdateFixOrderJob>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/jobs/bulk-update-fix-order/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminBulkUpdateWithMainPageDisplayOrder
   * @throws ApiError
   */
  public static v1AdminJobsBulkUpdateWithMainPageDisplayOrderCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminBulkUpdateWithMainPageDisplayOrderRequest>,
  }): CancelablePromise<Array<V1AdminBulkUpdateWithMainPageDisplayOrder>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/jobs/bulk-update-with-main-page-display-order/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminListJob
   * @throws ApiError
   */
  public static v1AdminJobsFixedList(): CancelablePromise<Array<V1AdminListJob>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/jobs/fixed/',
    });
  }

  /**
   * @returns V1AdminListJob
   * @throws ApiError
   */
  public static v1AdminJobsPublishedList(): CancelablePromise<Array<V1AdminListJob>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/jobs/published/',
    });
  }

  /**
   * @returns PaginatedV1AdminListNoticeList
   * @throws ApiError
   */
  public static v1AdminNoticesList({
    page,
    pageSize,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListNoticeList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/notices/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminCreateNotice
   * @throws ApiError
   */
  public static v1AdminNoticesCreate({
    formData,
  }: {
    formData: V1AdminCreateNoticeRequest,
  }): CancelablePromise<V1AdminCreateNotice> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/notices/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminRetrieveNotice
   * @throws ApiError
   */
  public static v1AdminNoticesRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 공지사항.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveNotice> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/notices/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminUpdateNotice
   * @throws ApiError
   */
  public static v1AdminNoticesUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 공지사항.
     */
    id: number,
    formData: V1AdminUpdateNoticeRequest,
  }): CancelablePromise<V1AdminUpdateNotice> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/notices/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminUpdateNotice
   * @throws ApiError
   */
  public static v1AdminNoticesPartialUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 공지사항.
     */
    id: number,
    formData?: PatchedV1AdminUpdateNoticeRequest,
  }): CancelablePromise<V1AdminUpdateNotice> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/notices/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminNoticesDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 공지사항.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/notices/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminBulkToggleNoticeFix
   * @throws ApiError
   */
  public static v1AdminNoticesBulkToggleFixCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminBulkToggleNoticeFixRequest>,
  }): CancelablePromise<Array<V1AdminBulkToggleNoticeFix>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/notices/bulk-toggle-fix/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminUpdateNoticeBulkUpdateOrders
   * @throws ApiError
   */
  public static v1AdminNoticesBulkUpdateOrdersCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminUpdateNoticeBulkUpdateOrdersRequest>,
  }): CancelablePromise<Array<V1AdminUpdateNoticeBulkUpdateOrders>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/notices/bulk-update-orders/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminListFixedNotice
   * @throws ApiError
   */
  public static v1AdminNoticesFixedList(): CancelablePromise<Array<V1AdminListFixedNotice>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/notices/fixed/',
    });
  }

  /**
   * @returns CheckPayment
   * @throws ApiError
   */
  public static v1AdminPaymentsCheckCreate({
    requestBody,
  }: {
    requestBody: CheckPaymentRequest,
  }): CancelablePromise<CheckPayment> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/payments/check/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1AdminListOrganizationPaymentList
   * @throws ApiError
   */
  public static v1AdminPaymentsOrganizationPaymentsList({
    organizationNameIcontains,
    organizationStaffInChargeIcontains,
    page,
    pageSize,
  }: {
    organizationNameIcontains?: string,
    organizationStaffInChargeIcontains?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListOrganizationPaymentList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/payments/organization-payments/',
      query: {
        'organization__name__icontains': organizationNameIcontains,
        'organization__staff_in_charge__icontains': organizationStaffInChargeIcontains,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminRetrieveOrganizationPayment
   * @throws ApiError
   */
  public static v1AdminPaymentsOrganizationPaymentsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 단체 접수 결제.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveOrganizationPayment> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/payments/organization-payments/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminApprovalOrganizationPayment
   * @throws ApiError
   */
  public static v1AdminPaymentsOrganizationPaymentsApprovalPartialUpdate({
    id,
  }: {
    /**
     * A unique integer value identifying this 단체 접수 결제.
     */
    id: number,
  }): CancelablePromise<V1AdminApprovalOrganizationPayment> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/payments/organization-payments/{id}/approval/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListPressReleaseList
   * @throws ApiError
   */
  public static v1AdminPressReleasesList({
    page,
    pageSize,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListPressReleaseList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/press-releases/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminCreatePressRelease
   * @throws ApiError
   */
  public static v1AdminPressReleasesCreate({
    formData,
  }: {
    formData: V1AdminCreatePressReleaseRequest,
  }): CancelablePromise<V1AdminCreatePressRelease> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/press-releases/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminRetrievePressRelease
   * @throws ApiError
   */
  public static v1AdminPressReleasesRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 보도 자료.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrievePressRelease> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/press-releases/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminUpdatePressRelease
   * @throws ApiError
   */
  public static v1AdminPressReleasesUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 보도 자료.
     */
    id: number,
    formData: V1AdminUpdatePressReleaseRequest,
  }): CancelablePromise<V1AdminUpdatePressRelease> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/press-releases/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminUpdatePressRelease
   * @throws ApiError
   */
  public static v1AdminPressReleasesPartialUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 보도 자료.
     */
    id: number,
    formData?: PatchedV1AdminUpdatePressReleaseRequest,
  }): CancelablePromise<V1AdminUpdatePressRelease> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/press-releases/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminPressReleasesDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 보도 자료.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/press-releases/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminBulkTogglePressReleaseFix
   * @throws ApiError
   */
  public static v1AdminPressReleasesBulkToggleFixCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminBulkTogglePressReleaseFixRequest>,
  }): CancelablePromise<Array<V1AdminBulkTogglePressReleaseFix>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/press-releases/bulk-toggle-fix/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminUpdatePressReleaseBulkUpdateOrders
   * @throws ApiError
   */
  public static v1AdminPressReleasesBulkUpdateOrdersCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminUpdatePressReleaseBulkUpdateOrdersRequest>,
  }): CancelablePromise<Array<V1AdminUpdatePressReleaseBulkUpdateOrders>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/press-releases/bulk-update-orders/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminListFixedPressRelease
   * @throws ApiError
   */
  public static v1AdminPressReleasesFixedList(): CancelablePromise<Array<V1AdminListFixedPressRelease>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/press-releases/fixed/',
    });
  }

  /**
   * @returns V1AdminApplicantsByClassificationStatistics
   * @throws ApiError
   */
  public static v1AdminStatisticsApplicantsApplicantsByClassificationList({
    year,
    month,
  }: {
    year: number,
    month?: number,
  }): CancelablePromise<Array<V1AdminApplicantsByClassificationStatistics>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/statistics/applicants/applicants-by-classification/',
      query: {
        'month': month,
        'year': year,
      },
    });
  }

  /**
   * @returns V1LevelDistributions
   * @throws ApiError
   */
  public static v1AdminStatisticsLevelDistributionsList({
    year,
    month,
    type,
  }: {
    year: number,
    month?: number,
    type?: 'OC' | 'RE' | 'SP',
  }): CancelablePromise<Array<V1LevelDistributions>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/statistics/level-distributions/',
      query: {
        'month': month,
        'type': type,
        'year': year,
      },
    });
  }

  /**
   * @returns V1PCCEApplicantStatistic
   * @throws ApiError
   */
  public static v1AdminStatisticsPcceApplicantsList({
    month,
    year,
  }: {
    month: number,
    year: number,
  }): CancelablePromise<Array<V1PCCEApplicantStatistic>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/statistics/pcce-applicants/',
      query: {
        'month': month,
        'year': year,
      },
    });
  }

  /**
   * @returns V1PCCPApplicantStatistic
   * @throws ApiError
   */
  public static v1AdminStatisticsPccpApplicantsList({
    month,
    year,
  }: {
    month: number,
    year: number,
  }): CancelablePromise<Array<V1PCCPApplicantStatistic>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/statistics/pccp-applicants/',
      query: {
        'month': month,
        'year': year,
      },
    });
  }

  /**
   * @returns V1PCSQLApplicantStatistic
   * @throws ApiError
   */
  public static v1AdminStatisticsPcsqlApplicantsList({
    month,
    year,
  }: {
    month: number,
    year: number,
  }): CancelablePromise<Array<V1PCSQLApplicantStatistic>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/statistics/pcsql-applicants/',
      query: {
        'month': month,
        'year': year,
      },
    });
  }

  /**
   * @returns V1AdminDaysSalesStatistics
   * @throws ApiError
   */
  public static v1AdminStatisticsSalesDaysList({
    year,
    month,
  }: {
    year: number,
    month?: number,
  }): CancelablePromise<Array<V1AdminDaysSalesStatistics>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/statistics/sales/days/',
      query: {
        'month': month,
        'year': year,
      },
    });
  }

  /**
   * @returns V1AdminPeriodSalesStatistics
   * @throws ApiError
   */
  public static v1AdminStatisticsSalesPeriodRetrieve({
    year,
    month,
  }: {
    year: number,
    month?: number,
  }): CancelablePromise<V1AdminPeriodSalesStatistics> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/statistics/sales/period/',
      query: {
        'month': month,
        'year': year,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListSurveyList
   * @throws ApiError
   */
  public static v1AdminSurveysList({
    page,
    pageSize,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListSurveyList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/surveys/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminCreateSurvey
   * @throws ApiError
   */
  public static v1AdminSurveysCreate({
    requestBody,
  }: {
    requestBody: V1AdminCreateSurveyRequest,
  }): CancelablePromise<V1AdminCreateSurvey> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/surveys/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminRetrieveSurvey
   * @throws ApiError
   */
  public static v1AdminSurveysRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 설문 조사.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveSurvey> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/surveys/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminUpdateSurvey
   * @throws ApiError
   */
  public static v1AdminSurveysUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 설문 조사.
     */
    id: number,
    requestBody: V1AdminUpdateSurveyRequest,
  }): CancelablePromise<V1AdminUpdateSurvey> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/surveys/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminUpdateSurvey
   * @throws ApiError
   */
  public static v1AdminSurveysPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 설문 조사.
     */
    id: number,
    requestBody?: PatchedV1AdminUpdateSurveyRequest,
  }): CancelablePromise<V1AdminUpdateSurvey> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/surveys/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminSurveysDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 설문 조사.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/surveys/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminResponsesSurvey
   * @throws ApiError
   */
  public static v1AdminSurveysResponsesRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 설문 조사.
     */
    id: number,
  }): CancelablePromise<V1AdminResponsesSurvey> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/surveys/{id}/responses/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns PaginatedListTryoutList
   * @throws ApiError
   */
  public static v1AdminTryoutsList({
    classificationId,
    hasSurvey,
    isAppliedVat,
    organization,
    organizationNameIcontains,
    page,
    pageSize,
    place,
    programmingLanguages,
    registrationEnd,
    registrationStart,
    site,
    startAtGte,
    startAtLte,
    type,
  }: {
    classificationId?: number,
    /**
     * 설문조사 포함 시험 여부
     */
    hasSurvey?: boolean,
    /**
     * 부가세 적용 여부
     */
    isAppliedVat?: boolean,
    organization?: number,
    organizationNameIcontains?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    place?: number,
    programmingLanguages?: Array<number>,
    registrationEnd?: string,
    registrationStart?: string,
    /**
     * MONITO : MO | OFFLINE : OF
     */
    site?: 'MO' | 'OF',
    startAtGte?: string,
    startAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    type?: 'OC' | 'RE' | 'SP',
  }): CancelablePromise<PaginatedListTryoutList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/',
      query: {
        'classification__id': classificationId,
        'has_survey': hasSurvey,
        'is_applied_vat': isAppliedVat,
        'organization': organization,
        'organization__name__icontains': organizationNameIcontains,
        'page': page,
        'page_size': pageSize,
        'place': place,
        'programming_languages': programmingLanguages,
        'registration_end': registrationEnd,
        'registration_start': registrationStart,
        'site': site,
        'start_at__gte': startAtGte,
        'start_at__lte': startAtLte,
        'type': type,
      },
    });
  }

  /**
   * @returns CreateTryout
   * @throws ApiError
   */
  public static v1AdminTryoutsCreate({
    requestBody,
  }: {
    requestBody: CreateTryoutRequest,
  }): CancelablePromise<CreateTryout> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/tryouts/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedListTryoutApplicantList
   * @throws ApiError
   */
  public static v1AdminTryoutsApplicantsList({
    paymentTryoutPk,
    listType,
    page,
    pageSize,
  }: {
    paymentTryoutPk: number,
    /**
     * RE : 접수 인원 | HR : 50% 환불 인원 | FR : 100% 환불 인원 | NR : 환불 제외 인원 | CO : 쿠폰 할인 인원 | VA : 유효 매출 인원 | PR : 할인권 인원 | FE : 응시권 인원
     */
    listType?: 'CO' | 'FE' | 'FR' | 'HR' | 'NR' | 'PR' | 'RE' | 'VA',
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedListTryoutApplicantList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/{payment__tryout_pk}/applicants/',
      path: {
        'payment__tryout_pk': paymentTryoutPk,
      },
      query: {
        'list_type': listType,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1AdminTryoutsApplicantsExcelRetrieve({
    paymentTryoutPk,
    listType,
  }: {
    paymentTryoutPk: number,
    /**
     * RE : 접수 인원 | HR : 50% 환불 인원 | FR : 100% 환불 인원 | NR : 환불 제외 인원 | CO : 쿠폰 할인 인원 | VA : 유효 매출 인원 | PR : 할인권 인원 | FE : 응시권 인원
     */
    listType?: 'CO' | 'FE' | 'FR' | 'HR' | 'NR' | 'PR' | 'RE' | 'VA',
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/{payment__tryout_pk}/applicants/excel/',
      path: {
        'payment__tryout_pk': paymentTryoutPk,
      },
      query: {
        'list_type': listType,
      },
    });
  }

  /**
   * @returns RetrieveTryout
   * @throws ApiError
   */
  public static v1AdminTryoutsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
  }): CancelablePromise<RetrieveTryout> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns UpdateTryout
   * @throws ApiError
   */
  public static v1AdminTryoutsUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
    requestBody: UpdateTryoutRequest,
  }): CancelablePromise<UpdateTryout> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/tryouts/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns UpdateTryout
   * @throws ApiError
   */
  public static v1AdminTryoutsPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
    requestBody?: PatchedUpdateTryoutRequest,
  }): CancelablePromise<UpdateTryout> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/tryouts/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminTryoutsDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/tryouts/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminChallenges
   * @throws ApiError
   */
  public static v1AdminTryoutsChallengesRetrieve({
    id,
    page = 1,
    pageSize = 20,
    used = true,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
    page?: number,
    pageSize?: number,
    used?: boolean,
  }): CancelablePromise<V1AdminChallenges> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/{id}/challenges/',
      path: {
        'id': id,
      },
      query: {
        'page': page,
        'page_size': pageSize,
        'used': used,
      },
    });
  }

  /**
   * @returns V1UpdateSalesManagement
   * @throws ApiError
   */
  public static v1AdminTryoutsSalesManagementPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
    requestBody?: PatchedV1UpdateSalesManagementRequest,
  }): CancelablePromise<V1UpdateSalesManagement> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/tryouts/{id}/sales-management/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1AdminTryoutsUpdateChallengesCreate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
    requestBody?: V1AdminUpdateChallengesRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/tryouts/{id}/update-challenges/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1SalesManagement
   * @throws ApiError
   */
  public static v1AdminTryoutsAllSalesManagementsList({
    classificationId,
    hasSurvey,
    isAppliedVat,
    organization,
    organizationNameIcontains,
    place,
    programmingLanguages,
    registrationEnd,
    registrationStart,
    site,
    startAtGte,
    startAtLte,
    type,
  }: {
    classificationId?: number,
    /**
     * 설문조사 포함 시험 여부
     */
    hasSurvey?: boolean,
    /**
     * 부가세 적용 여부
     */
    isAppliedVat?: boolean,
    organization?: number,
    organizationNameIcontains?: string,
    place?: number,
    programmingLanguages?: Array<number>,
    registrationEnd?: string,
    registrationStart?: string,
    /**
     * MONITO : MO | OFFLINE : OF
     */
    site?: 'MO' | 'OF',
    startAtGte?: string,
    startAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    type?: 'OC' | 'RE' | 'SP',
  }): CancelablePromise<Array<V1SalesManagement>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/all-sales-managements/',
      query: {
        'classification__id': classificationId,
        'has_survey': hasSurvey,
        'is_applied_vat': isAppliedVat,
        'organization': organization,
        'organization__name__icontains': organizationNameIcontains,
        'place': place,
        'programming_languages': programmingLanguages,
        'registration_end': registrationEnd,
        'registration_start': registrationStart,
        'site': site,
        'start_at__gte': startAtGte,
        'start_at__lte': startAtLte,
        'type': type,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListTryoutAppliesList
   * @throws ApiError
   */
  public static v1AdminTryoutsAppliesList({
    classificationId,
    organization,
    page,
    pageSize,
    startAtGte,
    startAtLte,
    type,
  }: {
    classificationId?: number,
    organization?: number,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    startAtGte?: string,
    startAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    type?: 'OC' | 'RE' | 'SP',
  }): CancelablePromise<PaginatedV1AdminListTryoutAppliesList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/applies/',
      query: {
        'classification__id': classificationId,
        'organization': organization,
        'page': page,
        'page_size': pageSize,
        'start_at__gte': startAtGte,
        'start_at__lte': startAtLte,
        'type': type,
      },
    });
  }

  /**
   * @returns LimitedUpdateTryout
   * @throws ApiError
   */
  public static v1AdminTryoutsLimitedUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
    requestBody: LimitedUpdateTryoutRequest,
  }): CancelablePromise<LimitedUpdateTryout> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/tryouts/limited/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns LimitedUpdateTryout
   * @throws ApiError
   */
  public static v1AdminTryoutsLimitedPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
    requestBody?: PatchedLimitedUpdateTryoutRequest,
  }): CancelablePromise<LimitedUpdateTryout> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/tryouts/limited/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedListTryoutPlaceList
   * @throws ApiError
   */
  public static v1AdminTryoutsPlacesList({
    page,
    pageSize,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedListTryoutPlaceList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/places/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns CreateTryoutPlace
   * @throws ApiError
   */
  public static v1AdminTryoutsPlacesCreate({
    formData,
  }: {
    formData: CreateTryoutPlaceRequest,
  }): CancelablePromise<CreateTryoutPlace> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/tryouts/places/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns RetrieveTryoutPlace
   * @throws ApiError
   */
  public static v1AdminTryoutsPlacesRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 시험 장소.
     */
    id: number,
  }): CancelablePromise<RetrieveTryoutPlace> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/places/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns UpdateTryoutPlace
   * @throws ApiError
   */
  public static v1AdminTryoutsPlacesUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 시험 장소.
     */
    id: number,
    formData: UpdateTryoutPlaceRequest,
  }): CancelablePromise<UpdateTryoutPlace> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/tryouts/places/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns UpdateTryoutPlace
   * @throws ApiError
   */
  public static v1AdminTryoutsPlacesPartialUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 시험 장소.
     */
    id: number,
    formData?: PatchedUpdateTryoutPlaceRequest,
  }): CancelablePromise<UpdateTryoutPlace> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/tryouts/places/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminTryoutsPlacesDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 시험 장소.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/tryouts/places/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns PaginatedV1SalesManagementList
   * @throws ApiError
   */
  public static v1AdminTryoutsSalesManagementsList({
    classificationId,
    hasSurvey,
    isAppliedVat,
    organization,
    organizationNameIcontains,
    page,
    pageSize,
    place,
    programmingLanguages,
    registrationEnd,
    registrationStart,
    site,
    startAtGte,
    startAtLte,
    type,
  }: {
    classificationId?: number,
    /**
     * 설문조사 포함 시험 여부
     */
    hasSurvey?: boolean,
    /**
     * 부가세 적용 여부
     */
    isAppliedVat?: boolean,
    organization?: number,
    organizationNameIcontains?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    place?: number,
    programmingLanguages?: Array<number>,
    registrationEnd?: string,
    registrationStart?: string,
    /**
     * MONITO : MO | OFFLINE : OF
     */
    site?: 'MO' | 'OF',
    startAtGte?: string,
    startAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    type?: 'OC' | 'RE' | 'SP',
  }): CancelablePromise<PaginatedV1SalesManagementList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/sales-managements/',
      query: {
        'classification__id': classificationId,
        'has_survey': hasSurvey,
        'is_applied_vat': isAppliedVat,
        'organization': organization,
        'organization__name__icontains': organizationNameIcontains,
        'page': page,
        'page_size': pageSize,
        'place': place,
        'programming_languages': programmingLanguages,
        'registration_end': registrationEnd,
        'registration_start': registrationStart,
        'site': site,
        'start_at__gte': startAtGte,
        'start_at__lte': startAtLte,
        'type': type,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1AdminTryoutsSalesManagementsExcelRetrieve({
    classificationId,
    hasSurvey,
    isAppliedVat,
    organization,
    organizationNameIcontains,
    place,
    programmingLanguages,
    registrationEnd,
    registrationStart,
    site,
    startAtGte,
    startAtLte,
    type,
  }: {
    classificationId?: number,
    /**
     * 설문조사 포함 시험 여부
     */
    hasSurvey?: boolean,
    /**
     * 부가세 적용 여부
     */
    isAppliedVat?: boolean,
    organization?: number,
    organizationNameIcontains?: string,
    place?: number,
    programmingLanguages?: Array<number>,
    registrationEnd?: string,
    registrationStart?: string,
    /**
     * MONITO : MO | OFFLINE : OF
     */
    site?: 'MO' | 'OF',
    startAtGte?: string,
    startAtLte?: string,
    /**
     * 시험 종류 - RE(정기 시험), SP(특별 시험), OC(수시 시험)
     */
    type?: 'OC' | 'RE' | 'SP',
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/tryouts/sales-managements-excel/',
      query: {
        'classification__id': classificationId,
        'has_survey': hasSurvey,
        'is_applied_vat': isAppliedVat,
        'organization': organization,
        'organization__name__icontains': organizationNameIcontains,
        'place': place,
        'programming_languages': programmingLanguages,
        'registration_end': registrationEnd,
        'registration_start': registrationStart,
        'site': site,
        'start_at__gte': startAtGte,
        'start_at__lte': startAtLte,
        'type': type,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListUniversityUseCaseList
   * @throws ApiError
   */
  public static v1AdminUniversityUseCasesList({
    page,
    pageSize,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListUniversityUseCaseList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/university-use-cases/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminCreateUniversityUseCase
   * @throws ApiError
   */
  public static v1AdminUniversityUseCasesCreate({
    formData,
  }: {
    formData: V1AdminCreateUniversityUseCaseRequest,
  }): CancelablePromise<V1AdminCreateUniversityUseCase> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/university-use-cases/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminRetrieveUniversityUseCase
   * @throws ApiError
   */
  public static v1AdminUniversityUseCasesRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 대학 활용 사례.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveUniversityUseCase> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/university-use-cases/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminUpdateUniversityUseCase
   * @throws ApiError
   */
  public static v1AdminUniversityUseCasesUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 대학 활용 사례.
     */
    id: number,
    formData: V1AdminUpdateUniversityUseCaseRequest,
  }): CancelablePromise<V1AdminUpdateUniversityUseCase> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/university-use-cases/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminUpdateUniversityUseCase
   * @throws ApiError
   */
  public static v1AdminUniversityUseCasesPartialUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 대학 활용 사례.
     */
    id: number,
    formData?: PatchedV1AdminUpdateUniversityUseCaseRequest,
  }): CancelablePromise<V1AdminUpdateUniversityUseCase> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/university-use-cases/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminUniversityUseCasesDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 대학 활용 사례.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/university-use-cases/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminBulkToggleUniversityUseCaseFix
   * @throws ApiError
   */
  public static v1AdminUniversityUseCasesBulkToggleFixCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminBulkToggleUniversityUseCaseFixRequest>,
  }): CancelablePromise<Array<V1AdminBulkToggleUniversityUseCaseFix>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/university-use-cases/bulk-toggle-fix/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminBulkUpdateUniversityUseCaseOrders
   * @throws ApiError
   */
  public static v1AdminUniversityUseCasesBulkUpdateOrdersCreate({
    requestBody,
  }: {
    requestBody: Array<V1AdminBulkUpdateUniversityUseCaseOrdersRequest>,
  }): CancelablePromise<Array<V1AdminBulkUpdateUniversityUseCaseOrders>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/university-use-cases/bulk-update-orders/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminListFixedUniversityUseCase
   * @throws ApiError
   */
  public static v1AdminUniversityUseCasesFixedList(): CancelablePromise<Array<V1AdminListFixedUniversityUseCase>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/university-use-cases/fixed/',
    });
  }

  /**
   * @returns PaginatedV1AdminListUserList
   * @throws ApiError
   */
  public static v1AdminUsersList({
    emailIcontains,
    isActive,
    isIdentified,
    nameIcontains,
    page,
    pageSize,
  }: {
    emailIcontains?: string,
    isActive?: boolean,
    isIdentified?: boolean,
    nameIcontains?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1AdminListUserList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/users/',
      query: {
        'email__icontains': emailIcontains,
        'is_active': isActive,
        'is_identified': isIdentified,
        'name__icontains': nameIcontains,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1AdminAllowReIdentification
   * @throws ApiError
   */
  public static v1AdminUsersAllowReIdentificationPartialUpdate({
    id,
  }: {
    /**
     * A unique integer value identifying this 사용자.
     */
    id: number,
  }): CancelablePromise<V1AdminAllowReIdentification> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/users/{id}/allow-re-identification/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminCancelIdentityVerification
   * @throws ApiError
   */
  public static v1AdminUsersCancelIdentityVerificationPartialUpdate({
    id,
  }: {
    /**
     * A unique integer value identifying this 사용자.
     */
    id: number,
  }): CancelablePromise<V1AdminCancelIdentityVerification> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/users/{id}/cancel-identity-verification/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListOrganizationLandingPageList
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationLandingPagesList({
    organizationNameIcontains,
    page,
    pageSize,
    slugIcontains,
  }: {
    organizationNameIcontains?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    slugIcontains?: string,
  }): CancelablePromise<PaginatedV1AdminListOrganizationLandingPageList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/users/organization-landing-pages/',
      query: {
        'organization__name__icontains': organizationNameIcontains,
        'page': page,
        'page_size': pageSize,
        'slug__icontains': slugIcontains,
      },
    });
  }

  /**
   * @returns V1AdminWriteOrganizationLandingPage
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationLandingPagesCreate({
    formData,
  }: {
    formData: V1AdminWriteOrganizationLandingPageRequest,
  }): CancelablePromise<V1AdminWriteOrganizationLandingPage> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/users/organization-landing-pages/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminRetrieveOrganizationLandingPage
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationLandingPagesRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 단체 랜딩 페이지.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveOrganizationLandingPage> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/users/organization-landing-pages/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminWriteOrganizationLandingPage
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationLandingPagesUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 단체 랜딩 페이지.
     */
    id: number,
    formData: V1AdminWriteOrganizationLandingPageRequest,
  }): CancelablePromise<V1AdminWriteOrganizationLandingPage> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/users/organization-landing-pages/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminWriteOrganizationLandingPage
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationLandingPagesPartialUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 단체 랜딩 페이지.
     */
    id: number,
    formData?: PatchedV1AdminWriteOrganizationLandingPageRequest,
  }): CancelablePromise<V1AdminWriteOrganizationLandingPage> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/users/organization-landing-pages/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationLandingPagesDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 단체 랜딩 페이지.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/users/organization-landing-pages/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns PaginatedV1AdminListOrganizationList
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsList({
    address,
    nameIcontains,
    page,
    pageSize,
    staffInChargeIcontains,
    user,
  }: {
    address?: string,
    nameIcontains?: string,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    staffInChargeIcontains?: string,
    user?: string,
  }): CancelablePromise<PaginatedV1AdminListOrganizationList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/users/organizations/',
      query: {
        'address': address,
        'name__icontains': nameIcontains,
        'page': page,
        'page_size': pageSize,
        'staff_in_charge__icontains': staffInChargeIcontains,
        'user': user,
      },
    });
  }

  /**
   * @returns V1AdminCreateOrganization
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsCreate({
    formData,
  }: {
    formData: V1AdminCreateOrganizationRequest,
  }): CancelablePromise<V1AdminCreateOrganization> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/users/organizations/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminListOrganizationOrganizationPrice
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsOrganizationPricesList({
    organizationPk,
  }: {
    organizationPk: number,
  }): CancelablePromise<Array<V1AdminListOrganizationOrganizationPrice>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/users/organizations/{organization_pk}/organization-prices/',
      path: {
        'organization_pk': organizationPk,
      },
    });
  }

  /**
   * @returns V1AdminCreateOrganizationOrganizationPrice
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsOrganizationPricesCreate({
    organizationPk,
    requestBody,
  }: {
    organizationPk: number,
    requestBody: V1AdminCreateOrganizationOrganizationPriceRequest,
  }): CancelablePromise<V1AdminCreateOrganizationOrganizationPrice> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin/users/organizations/{organization_pk}/organization-prices/',
      path: {
        'organization_pk': organizationPk,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminListOrganizationOrganizationPrice
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsOrganizationPricesRetrieve({
    id,
    organizationPk,
  }: {
    /**
     * A unique integer value identifying this 단체 적용 금액.
     */
    id: number,
    organizationPk: number,
  }): CancelablePromise<V1AdminListOrganizationOrganizationPrice> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/users/organizations/{organization_pk}/organization-prices/{id}/',
      path: {
        'id': id,
        'organization_pk': organizationPk,
      },
    });
  }

  /**
   * @returns V1AdminCreateOrganizationOrganizationPrice
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsOrganizationPricesUpdate({
    id,
    organizationPk,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 단체 적용 금액.
     */
    id: number,
    organizationPk: number,
    requestBody: V1AdminCreateOrganizationOrganizationPriceRequest,
  }): CancelablePromise<V1AdminCreateOrganizationOrganizationPrice> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/users/organizations/{organization_pk}/organization-prices/{id}/',
      path: {
        'id': id,
        'organization_pk': organizationPk,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AdminCreateOrganizationOrganizationPrice
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsOrganizationPricesPartialUpdate({
    id,
    organizationPk,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 단체 적용 금액.
     */
    id: number,
    organizationPk: number,
    requestBody?: PatchedV1AdminCreateOrganizationOrganizationPriceRequest,
  }): CancelablePromise<V1AdminCreateOrganizationOrganizationPrice> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/users/organizations/{organization_pk}/organization-prices/{id}/',
      path: {
        'id': id,
        'organization_pk': organizationPk,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsOrganizationPricesDestroy({
    id,
    organizationPk,
  }: {
    /**
     * A unique integer value identifying this 단체 적용 금액.
     */
    id: number,
    organizationPk: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/users/organizations/{organization_pk}/organization-prices/{id}/',
      path: {
        'id': id,
        'organization_pk': organizationPk,
      },
    });
  }

  /**
   * @returns V1AdminRetrieveOrganization
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 단체.
     */
    id: number,
  }): CancelablePromise<V1AdminRetrieveOrganization> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin/users/organizations/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AdminUpdateOrganization
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 단체.
     */
    id: number,
    formData: V1AdminUpdateOrganizationRequest,
  }): CancelablePromise<V1AdminUpdateOrganization> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/admin/users/organizations/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1AdminUpdateOrganization
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsPartialUpdate({
    id,
    formData,
  }: {
    /**
     * A unique integer value identifying this 단체.
     */
    id: number,
    formData?: PatchedV1AdminUpdateOrganizationRequest,
  }): CancelablePromise<V1AdminUpdateOrganization> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin/users/organizations/{id}/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AdminUsersOrganizationsDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 단체.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin/users/organizations/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns ListApplicant
   * @throws ApiError
   */
  public static v1ApplicantsList({
    createdGte,
    createdLte,
    order,
    paymentApplicantApplicantStatus,
    paymentTryoutClassificationId,
  }: {
    createdGte?: string,
    createdLte?: string,
    /**
     * 순서
     */
    order?: Array<'-id' | 'id'>,
    /**
     * RE : 접수 완료 | CA : 접수 취소 | DO : 응시 완료 | NT : 미응시
     */
    paymentApplicantApplicantStatus?: 'CA' | 'DO' | 'NT' | 'RE',
    paymentTryoutClassificationId?: number,
  }): CancelablePromise<Array<ListApplicant>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/applicants/',
      query: {
        'created__gte': createdGte,
        'created__lte': createdLte,
        'order': order,
        'payment__applicant__applicant_status': paymentApplicantApplicantStatus,
        'payment__tryout__classification__id': paymentTryoutClassificationId,
      },
    });
  }

  /**
   * @returns RetrieveApplicant
   * @throws ApiError
   */
  public static v1ApplicantsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 유효 응시자.
     */
    id: number,
  }): CancelablePromise<RetrieveApplicant> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/applicants/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1CancelApplicant
   * @throws ApiError
   */
  public static v1ApplicantsCancelCreate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 유효 응시자.
     */
    id: number,
    requestBody: V1CancelApplicantRequest,
  }): CancelablePromise<V1CancelApplicant> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/applicants/{id}/cancel/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns ListApplicantResult
   * @throws ApiError
   */
  public static v1ApplicantsApplicantResultsList(): CancelablePromise<Array<ListApplicantResult>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/applicants/applicant-results/',
    });
  }

  /**
   * @returns RetrieveApplicantResult
   * @throws ApiError
   */
  public static v1ApplicantsApplicantResultsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 유저 응시 결과.
     */
    id: number,
  }): CancelablePromise<RetrieveApplicantResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/applicants/applicant-results/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1AuthenticityApplicantResults
   * @throws ApiError
   */
  public static v1ApplicantsApplicantResultsAuthenticityCreate({
    requestBody,
  }: {
    requestBody: V1AuthenticityApplicantResultsRequest,
  }): CancelablePromise<V1AuthenticityApplicantResults> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/applicants/applicant-results/authenticity/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1AuthenticityApplicantResults
   * @throws ApiError
   */
  public static v1ApplicantsApplicantResultsAuthenticityExcelCreate({
    formData,
  }: {
    formData: V1AuthenticityExcelApplicantResultRequest,
  }): CancelablePromise<V1AuthenticityApplicantResults> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/applicants/applicant-results/authenticity_excel/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1ApplicantsApplicantResultsDownloadSampleExcelRetrieve(): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/applicants/applicant-results/download-sample-excel/',
    });
  }

  /**
   * @returns V1AppliesApplicant
   * @throws ApiError
   */
  public static v1ApplicantsAppliesList(): CancelablePromise<Array<V1AppliesApplicant>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/applicants/applies/',
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1ApplicantsEntranceCreate({
    requestBody,
  }: {
    requestBody: V1EntranceApplicantRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/applicants/entrance/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1ApplicantsFinishPreTestCreate({
    requestBody,
  }: {
    requestBody: V1FinishPreTestApplicantRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/applicants/finish-pre-test/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1ListOrganizationApplicantList
   * @throws ApiError
   */
  public static v1ApplicantsOrganizationApplicantsList({
    applicantStatus,
    page,
    pageSize,
    query,
  }: {
    /**
     * RE : 접수 완료 | CA : 접수 취소 | DO : 응시 완료 | NT : 미응시
     */
    applicantStatus?: 'CA' | 'DO' | 'NT' | 'RE',
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    /**
     * 응시자의 이름 또는 이메일 일부을 입력 하시면 해당 쿼리가 포함된 결과를 반환합니다.
     */
    query?: string,
  }): CancelablePromise<PaginatedV1ListOrganizationApplicantList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/applicants/organization-applicants/',
      query: {
        'applicant_status': applicantStatus,
        'page': page,
        'page_size': pageSize,
        'query': query,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1ApplicantsOrganizationApplicantsExcelRetrieve({
    applicantStatus,
    query,
  }: {
    /**
     * RE : 접수 완료 | CA : 접수 취소 | DO : 응시 완료 | NT : 미응시
     */
    applicantStatus?: 'CA' | 'DO' | 'NT' | 'RE',
    /**
     * 응시자의 이름 또는 이메일 일부을 입력 하시면 해당 쿼리가 포함된 결과를 반환합니다.
     */
    query?: string,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/applicants/organization-applicants/excel/',
      query: {
        'applicant_status': applicantStatus,
        'query': query,
      },
    });
  }

  /**
   * @returns V1PreTestApplicant
   * @throws ApiError
   */
  public static v1ApplicantsPreTestList(): CancelablePromise<Array<V1PreTestApplicant>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/applicants/pre-test/',
    });
  }

  /**
   * @returns V1ListClientApp
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsList(): CancelablePromise<Array<V1ListClientApp>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/authorizations/client-apps/',
    });
  }

  /**
   * @returns V1CreateClientApp
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsCreate({
    requestBody,
  }: {
    requestBody?: V1CreateClientAppRequest,
  }): CancelablePromise<V1CreateClientApp> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/authorizations/client-apps/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1ListClientAppAuthentication
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsAuthenticationsList({
    clientAppPk,
  }: {
    clientAppPk: number,
  }): CancelablePromise<Array<V1ListClientAppAuthentication>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/authorizations/client-apps/{client_app_pk}/authentications/',
      path: {
        'client_app_pk': clientAppPk,
      },
    });
  }

  /**
   * @returns V1CreateClientAppAuthentication
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsAuthenticationsCreate({
    clientAppPk,
  }: {
    clientAppPk: number,
  }): CancelablePromise<V1CreateClientAppAuthentication> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/authorizations/client-apps/{client_app_pk}/authentications/',
      path: {
        'client_app_pk': clientAppPk,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsAuthenticationsDestroy({
    clientAppPk,
    id,
  }: {
    clientAppPk: number,
    /**
     * A unique integer value identifying this 클라이언트 앱 인증.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/authorizations/client-apps/{client_app_pk}/authentications/{id}/',
      path: {
        'client_app_pk': clientAppPk,
        'id': id,
      },
    });
  }

  /**
   * @returns V1RetrieveClientApp
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 클라이언트 앱.
     */
    id: number,
  }): CancelablePromise<V1RetrieveClientApp> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/authorizations/client-apps/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1UpdateClientApp
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 클라이언트 앱.
     */
    id: number,
    requestBody?: V1UpdateClientAppRequest,
  }): CancelablePromise<V1UpdateClientApp> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/authorizations/client-apps/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1UpdateClientApp
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 클라이언트 앱.
     */
    id: number,
    requestBody?: PatchedV1UpdateClientAppRequest,
  }): CancelablePromise<V1UpdateClientApp> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/authorizations/client-apps/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsDestroy({
    id,
  }: {
    /**
     * A unique integer value identifying this 클라이언트 앱.
     */
    id: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/authorizations/client-apps/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1RetrieveClientAppByAppId
   * @throws ApiError
   */
  public static v1AuthorizationsClientAppsOriginsByAppIdRetrieve({
    appId,
  }: {
    appId: string,
  }): CancelablePromise<V1RetrieveClientAppByAppId> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/authorizations/client-apps/origins-by-app-id/{app_id}/',
      path: {
        'app_id': appId,
      },
    });
  }

  /**
   * @returns V1ListBanner
   * @throws ApiError
   */
  public static v1BannersList(): CancelablePromise<Array<V1ListBanner>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/banners/',
    });
  }

  /**
   * @returns V1ListCertificate
   * @throws ApiError
   */
  public static v1CertificateList(): CancelablePromise<Array<V1ListCertificate>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/certificate/',
    });
  }

  /**
   * @returns V1RetrieveCertificate
   * @throws ApiError
   */
  public static v1CertificateRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 유저 자격증.
     */
    id: number,
  }): CancelablePromise<V1RetrieveCertificate> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/certificate/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1ShareCertificate
   * @throws ApiError
   */
  public static v1CertificateSharePartialUpdate({
    id,
  }: {
    /**
     * A unique integer value identifying this 유저 자격증.
     */
    id: number,
  }): CancelablePromise<V1ShareCertificate> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/certificate/{id}/share/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1SharedCertificate
   * @throws ApiError
   */
  public static v1CertificateSharedRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 유저 자격증.
     */
    id: number,
  }): CancelablePromise<V1SharedCertificate> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/certificate/{id}/shared/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1ListProgrammersCertificate
   * @throws ApiError
   */
  public static v1CertificateProgrammersCertificatesList({
    programmersUserId,
  }: {
    programmersUserId: number,
  }): CancelablePromise<Array<V1ListProgrammersCertificate>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/certificate/{programmers_user_id}/programmers-certificates/',
      path: {
        'programmers_user_id': programmersUserId,
      },
    });
  }

  /**
   * API endpoint for selected certificates.
   * @returns V1CreateSelectedCertificate
   * @throws ApiError
   */
  public static v1CertificateSelectedCertificatesCreate({
    requestBody,
  }: {
    requestBody: V1CreateSelectedCertificateRequest,
  }): CancelablePromise<V1CreateSelectedCertificate> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/certificate/selected-certificates/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * API endpoint for selected certificates.
   * @returns V1RetrieveSelectedCertificate
   * @throws ApiError
   */
  public static v1CertificateSelectedCertificatesRetrieve({
    token,
  }: {
    token: string,
  }): CancelablePromise<V1RetrieveSelectedCertificate> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/certificate/selected-certificates/{token}/',
      path: {
        'token': token,
      },
    });
  }

  /**
   * @returns CreateCheatingReport
   * @throws ApiError
   */
  public static v1CheatingReportsCreate({
    formData,
  }: {
    formData: CreateCheatingReportRequest,
  }): CancelablePromise<CreateCheatingReport> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/cheating-reports/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns ListClassification
   * @throws ApiError
   */
  public static v1ClassficationsList(): CancelablePromise<Array<ListClassification>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/classfications/',
    });
  }

  /**
   * @returns V1ListTryoutCouponAssignment
   * @throws ApiError
   */
  public static v1CouponsTryoutCouponAssignmentsList({
    available,
    order,
  }: {
    available?: boolean,
    /**
     * 순서
     */
    order?: Array<'-coupon__end_at' | '-modified' | 'coupon__end_at' | 'modified'>,
  }): CancelablePromise<Array<V1ListTryoutCouponAssignment>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/coupons/tryout-coupon-assignments/',
      query: {
        'available': available,
        'order': order,
      },
    });
  }

  /**
   * @returns V1CreateTryoutCouponAssignment
   * @throws ApiError
   */
  public static v1CouponsTryoutCouponAssignmentsCreate({
    requestBody,
  }: {
    requestBody: V1CreateTryoutCouponAssignmentRequest,
  }): CancelablePromise<V1CreateTryoutCouponAssignment> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/coupons/tryout-coupon-assignments/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1ListEnterpriseUseCaseList
   * @throws ApiError
   */
  public static v1EnterpriseUseCasesList({
    classificationsId,
    demandEssentialSkill,
    demandEtc,
    demandOptionalSkill,
    order,
    page,
    pageSize,
  }: {
    classificationsId?: number,
    demandEssentialSkill?: boolean,
    demandEtc?: boolean,
    demandOptionalSkill?: boolean,
    /**
     * 순서
     */
    order?: Array<'-name' | '-new' | 'name' | 'new'>,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1ListEnterpriseUseCaseList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/enterprise-use-cases/',
      query: {
        'classifications__id': classificationsId,
        'demand_essential_skill': demandEssentialSkill,
        'demand_etc': demandEtc,
        'demand_optional_skill': demandOptionalSkill,
        'order': order,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns PaginatedV1LogosEnterpriseUseCaseList
   * @throws ApiError
   */
  public static v1EnterpriseUseCasesLogosList({
    classificationsId,
    demandEssentialSkill,
    demandEtc,
    demandOptionalSkill,
    order,
    page,
    pageSize,
  }: {
    classificationsId?: number,
    demandEssentialSkill?: boolean,
    demandEtc?: boolean,
    demandOptionalSkill?: boolean,
    /**
     * 순서
     */
    order?: Array<'-name' | '-new' | 'name' | 'new'>,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1LogosEnterpriseUseCaseList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/enterprise-use-cases/logos/',
      query: {
        'classifications__id': classificationsId,
        'demand_essential_skill': demandEssentialSkill,
        'demand_etc': demandEtc,
        'demand_optional_skill': demandOptionalSkill,
        'order': order,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1CreateGroupTryoutCounseling
   * @throws ApiError
   */
  public static v1GroupTryoutCounselingsCreate({
    requestBody,
  }: {
    requestBody: V1CreateGroupTryoutCounselingRequest,
  }): CancelablePromise<V1CreateGroupTryoutCounseling> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/group-tryout-counselings/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1ListJobList
   * @throws ApiError
   */
  public static v1JobsList({
    classificationId,
    order,
    page,
    pageSize,
    skillLevel,
  }: {
    classificationId?: number,
    /**
     * 순서
     */
    order?: Array<'-old' | '-registration_end_datetime' | 'old' | 'registration_end_datetime'>,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    skillLevel?: number,
  }): CancelablePromise<PaginatedV1ListJobList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/jobs/',
      query: {
        'classification__id': classificationId,
        'order': order,
        'page': page,
        'page_size': pageSize,
        'skill_level': skillLevel,
      },
    });
  }

  /**
   * @returns V1RetrieveJob
   * @throws ApiError
   */
  public static v1JobsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 채용 정보.
     */
    id: number,
  }): CancelablePromise<V1RetrieveJob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/jobs/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1ListJob
   * @throws ApiError
   */
  public static v1JobsPublishedList(): CancelablePromise<Array<V1ListJob>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/jobs/published/',
    });
  }

  /**
   * @returns V1CreateActionTracking
   * @throws ApiError
   */
  public static v1LogsActionsTrackingsCreate({
    requestBody,
  }: {
    requestBody: V1CreateActionTrackingRequest,
  }): CancelablePromise<V1CreateActionTracking> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/logs/actions-trackings/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1ListNoticeList
   * @throws ApiError
   */
  public static v1NoticesList({
    page,
    pageSize,
    titleIcontains,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    titleIcontains?: string,
  }): CancelablePromise<PaginatedV1ListNoticeList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/notices/',
      query: {
        'page': page,
        'page_size': pageSize,
        'title__icontains': titleIcontains,
      },
    });
  }

  /**
   * @returns V1RetrieveNotice
   * @throws ApiError
   */
  public static v1NoticesRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 공지사항.
     */
    id: number,
  }): CancelablePromise<V1RetrieveNotice> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/notices/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1ListFixedNotice
   * @throws ApiError
   */
  public static v1NoticesFixedList(): CancelablePromise<Array<V1ListFixedNotice>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/notices/fixed/',
    });
  }

  /**
   * @returns CreatePayment
   * @throws ApiError
   */
  public static v1PaymentsCreate({
    requestBody,
  }: {
    requestBody: CreatePaymentRequest,
  }): CancelablePromise<CreatePayment> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/payments/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1InfoPayment
   * @throws ApiError
   */
  public static v1PaymentsInfoRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 유저 결제.
     */
    id: number,
  }): CancelablePromise<V1InfoPayment> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/payments/{id}/info/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns UpdatePayment
   * @throws ApiError
   */
  public static v1PaymentsIamportWebhookCreate({
    requestBody,
  }: {
    requestBody?: UpdatePaymentRequest,
  }): CancelablePromise<UpdatePayment> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/payments/iamport/webhook/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1ListOrganizationPayment
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsList({
    createdGte,
    createdLte,
    status,
  }: {
    createdGte?: string,
    createdLte?: string,
    /**
     * CO : 접수 완료 | CA : 접수 취소 | EN : 시험 종료 | WA : 승인 대기
     */
    status?: 'CA' | 'CO' | 'EN' | 'WA',
  }): CancelablePromise<Array<V1ListOrganizationPayment>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/payments/organization-payments/',
      query: {
        'created__gte': createdGte,
        'created__lte': createdLte,
        'status': status,
      },
    });
  }

  /**
   * @returns V1CreateOrganizationPayment
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsCreate({
    requestBody,
  }: {
    requestBody: V1CreateOrganizationPaymentRequest,
  }): CancelablePromise<V1CreateOrganizationPayment> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/payments/organization-payments/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1RetrieveOrganizationPayment
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 단체 접수 결제.
     */
    id: number,
  }): CancelablePromise<V1RetrieveOrganizationPayment> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/payments/organization-payments/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1CancelOrganizationPayment
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsCancelCreate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 단체 접수 결제.
     */
    id: number,
    requestBody: V1CancelOrganizationPaymentRequest,
  }): CancelablePromise<V1CancelOrganizationPayment> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/payments/organization-payments/{id}/cancel/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1CompletionOrganizationPayment
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsCompletionRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 단체 접수 결제.
     */
    id: number,
  }): CancelablePromise<V1CompletionOrganizationPayment> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/payments/organization-payments/{id}/completion/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1PartialCancelOrganizationPayment
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsPartialCancelCreate({
    id,
    requestBody,
  }: {
    /**
     * A unique integer value identifying this 단체 접수 결제.
     */
    id: number,
    requestBody: V1PartialCancelOrganizationPaymentRequest,
  }): CancelablePromise<V1PartialCancelOrganizationPayment> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/payments/organization-payments/{id}/partial-cancel/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1ListOrganizationPaymentApplicant
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsApplicantsApplicantsList({
    paymentOrganizationPaymentPk,
  }: {
    paymentOrganizationPaymentPk: number,
  }): CancelablePromise<Array<V1ListOrganizationPaymentApplicant>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/payments/organization-payments/applicants/{payment__organization_payment_pk}/applicants/',
      path: {
        'payment__organization_payment_pk': paymentOrganizationPaymentPk,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsApplicantsApplicantsExcelRetrieve({
    paymentOrganizationPaymentPk,
  }: {
    paymentOrganizationPaymentPk: number,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/payments/organization-payments/applicants/{payment__organization_payment_pk}/applicants/excel/',
      path: {
        'payment__organization_payment_pk': paymentOrganizationPaymentPk,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsDownloadExcelRetrieve(): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/payments/organization-payments/download-excel/',
    });
  }

  /**
   * @returns V1UploadExcelOrganizationPaymentResponse
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsUploadExcelCreate({
    formData,
  }: {
    formData: V1UploadExcelOrganizationPaymentRequestRequest,
  }): CancelablePromise<V1UploadExcelOrganizationPaymentResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/payments/organization-payments/upload-excel/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns V1OrganizationPaymentApplicantSerializers
   * @throws ApiError
   */
  public static v1PaymentsOrganizationPaymentsValidateApplicantsCreate({
    requestBody,
  }: {
    requestBody: V1OrganizationPaymentApplicantSerializersRequest,
  }): CancelablePromise<V1OrganizationPaymentApplicantSerializers> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/payments/organization-payments/validate-applicants/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1ListPressReleaseList
   * @throws ApiError
   */
  public static v1PressReleasesList({
    page,
    pageSize,
    titleIcontains,
  }: {
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    titleIcontains?: string,
  }): CancelablePromise<PaginatedV1ListPressReleaseList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/press-releases/',
      query: {
        'page': page,
        'page_size': pageSize,
        'title__icontains': titleIcontains,
      },
    });
  }

  /**
   * @returns V1RetrievePressRelease
   * @throws ApiError
   */
  public static v1PressReleasesRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 보도 자료.
     */
    id: number,
  }): CancelablePromise<V1RetrievePressRelease> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/press-releases/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1ListFixedPressRelease
   * @throws ApiError
   */
  public static v1PressReleasesFixedList(): CancelablePromise<Array<V1ListFixedPressRelease>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/press-releases/fixed/',
    });
  }

  /**
   * @returns ListProgrammingLangauge
   * @throws ApiError
   */
  public static v1ProgrammingLanguagesList(): CancelablePromise<Array<ListProgrammingLangauge>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/programming-languages/',
    });
  }

  /**
   * @returns ListRegulation
   * @throws ApiError
   */
  public static v1RegulationsList({
    scope,
  }: {
    /**
     *
     * 규정 종류 - URE(회원 가입),
     * GUC(보호자 개인정보 수집 및 이용 동의),
     * ORR(단체 회원 가입),
     * ARE(시험 응시),
     * TGU(수시 시험),
     * SAU(성적 진위 여부),
     * GTC(단체 시험 상담),
     * CRE(부정 행위 신고),
     * ETC(기타)
     *
     */
    scope?: 'ARE' | 'CRE' | 'ETC' | 'GTC' | 'GUC' | 'ORR' | 'SAU' | 'TGU' | 'URE',
  }): CancelablePromise<Array<ListRegulation>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/regulations/',
      query: {
        'scope': scope,
      },
    });
  }

  /**
   * @returns ListRule
   * @throws ApiError
   */
  public static v1RulesList(): CancelablePromise<Array<ListRule>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/rules/',
    });
  }

  /**
   * @returns V1ListSampleChallenge
   * @throws ApiError
   */
  public static v1SamplesList(): CancelablePromise<Array<V1ListSampleChallenge>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/samples/',
    });
  }

  /**
   * @returns V1RetrieveSurvey
   * @throws ApiError
   */
  public static v1SurveysRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 설문 조사.
     */
    id: number,
  }): CancelablePromise<V1RetrieveSurvey> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/surveys/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1SurveysSurveyResponsesBulkCreateCreate({
    requestBody,
  }: {
    requestBody: Array<V1BulkCreateSurveyResponseRequest>,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/surveys/survey-responses/bulk-create/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1BannerListTryout
   * @throws ApiError
   */
  public static v1TryoutsLandingList({
    classification,
  }: {
    classification?: number,
  }): CancelablePromise<Array<V1BannerListTryout>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/tryouts/landing/',
      query: {
        'classification': classification,
      },
    });
  }

  /**
   * @returns V1ListOrganizationResultTryout
   * @throws ApiError
   */
  public static v1TryoutsOrganizationResultsList(): CancelablePromise<Array<V1ListOrganizationResultTryout>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/tryouts/organization-results/',
    });
  }

  /**
   * @returns PaginatedV1ListOrganizationResultApplicantList
   * @throws ApiError
   */
  public static v1TryoutsOrganizationResultsApplicantsList({
    paymentTryoutPk,
    isDone,
    isPassed,
    page,
    pageSize,
    search,
  }: {
    paymentTryoutPk: number,
    /**
     * 응시 여부에 따른 응시자를 반환합니다.
     */
    isDone?: boolean,
    /**
     * 합격 여부에 따른 응시자를 반환합니다.
     */
    isPassed?: boolean,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
    /**
     * 입력한 문자열과 매칭되는 이름, 혹은 이메일 응시자를 반환합니다.
     */
    search?: string,
  }): CancelablePromise<PaginatedV1ListOrganizationResultApplicantList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/tryouts/organization-results/{payment__tryout_pk}/applicants/',
      path: {
        'payment__tryout_pk': paymentTryoutPk,
      },
      query: {
        'is_done': isDone,
        'is_passed': isPassed,
        'page': page,
        'page_size': pageSize,
        'search': search,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public static v1TryoutsOrganizationResultsApplicantsExcelRetrieve({
    paymentTryoutPk,
    isDone,
    isPassed,
    search,
  }: {
    paymentTryoutPk: number,
    /**
     * 응시 여부에 따른 응시자를 반환합니다.
     */
    isDone?: boolean,
    /**
     * 합격 여부에 따른 응시자를 반환합니다.
     */
    isPassed?: boolean,
    /**
     * 입력한 문자열과 매칭되는 이름, 혹은 이메일 응시자를 반환합니다.
     */
    search?: string,
  }): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/tryouts/organization-results/{payment__tryout_pk}/applicants/excel/',
      path: {
        'payment__tryout_pk': paymentTryoutPk,
      },
      query: {
        'is_done': isDone,
        'is_passed': isPassed,
        'search': search,
      },
    });
  }

  /**
   * @returns V1RetrieveOrganizationTryout
   * @throws ApiError
   */
  public static v1TryoutsOrganizationRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
  }): CancelablePromise<V1RetrieveOrganizationTryout> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/tryouts/organization/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1UpdateProgrammersTryout
   * @throws ApiError
   */
  public static v1TryoutsProgrammersUpdate({
    programmersTryoutId,
    requestBody,
  }: {
    programmersTryoutId: number,
    requestBody?: V1UpdateProgrammersTryoutRequest,
  }): CancelablePromise<V1UpdateProgrammersTryout> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/tryouts/programmers/{programmers_tryout_id}/',
      path: {
        'programmers_tryout_id': programmersTryoutId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1UpdateProgrammersTryout
   * @throws ApiError
   */
  public static v1TryoutsProgrammersPartialUpdate({
    programmersTryoutId,
    requestBody,
  }: {
    programmersTryoutId: number,
    requestBody?: PatchedV1UpdateProgrammersTryoutRequest,
  }): CancelablePromise<V1UpdateProgrammersTryout> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/tryouts/programmers/{programmers_tryout_id}/',
      path: {
        'programmers_tryout_id': programmersTryoutId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PublishedListTryout
   * @throws ApiError
   */
  public static v1TryoutsPublishedList({
    classification,
    nowDatetime,
    site,
  }: {
    classification?: number,
    nowDatetime?: string,
    /**
     * MONITO : MO | OFFLINE : OF
     */
    site?: 'MO' | 'OF',
  }): CancelablePromise<Array<PublishedListTryout>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/tryouts/published/',
      query: {
        'classification': classification,
        'now_datetime': nowDatetime,
        'site': site,
      },
    });
  }

  /**
   * @returns PublishedRetrieveTryout
   * @throws ApiError
   */
  public static v1TryoutsPublishedRetrieve({
    id,
  }: {
    /**
     * A unique integer value identifying this 시험.
     */
    id: number,
  }): CancelablePromise<PublishedRetrieveTryout> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/tryouts/published/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns V1SendEmailTryoutEmployeeVerification
   * @throws ApiError
   */
  public static v1TryoutsTryoutEmployeeVerificationsSendEmailCreate({
    requestBody,
  }: {
    requestBody: V1SendEmailTryoutEmployeeVerificationRequest,
  }): CancelablePromise<V1SendEmailTryoutEmployeeVerification> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/tryouts/tryout-employee-verifications/send-email/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1VerifyTryoutEmployeeVerification
   * @throws ApiError
   */
  public static v1TryoutsTryoutEmployeeVerificationsVerifyCreate({
    requestBody,
  }: {
    requestBody: V1VerifyTryoutEmployeeVerificationRequest,
  }): CancelablePromise<V1VerifyTryoutEmployeeVerification> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/tryouts/tryout-employee-verifications/verify/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedV1ListUniversityUseCaseList
   * @throws ApiError
   */
  public static v1UniversityUseCasesList({
    classificationsId,
    demandAdmission,
    demandGrades,
    demandScholarship,
    order,
    page,
    pageSize,
  }: {
    classificationsId?: number,
    demandAdmission?: boolean,
    demandGrades?: boolean,
    demandScholarship?: boolean,
    /**
     * 순서
     */
    order?: Array<'-name' | '-new' | 'name' | 'new'>,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1ListUniversityUseCaseList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/university-use-cases/',
      query: {
        'classifications__id': classificationsId,
        'demand_admission': demandAdmission,
        'demand_grades': demandGrades,
        'demand_scholarship': demandScholarship,
        'order': order,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns any No Response
   * @throws ApiError
   */
  public static v1UsersActivateCreate({
    requestBody,
  }: {
    requestBody: LoginRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/activate/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1Authenticate
   * @throws ApiError
   */
  public static v1UsersAuthenticateCancelPartialUpdate(): CancelablePromise<V1Authenticate> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/users/authenticate/cancel/',
    });
  }

  /**
   * @returns V1Authenticate
   * @throws ApiError
   */
  public static v1UsersAuthenticateGeneralCreate({
    requestBody,
  }: {
    requestBody: V1AuthenticationRequestRequest,
  }): CancelablePromise<V1Authenticate> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/authenticate/general/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1UsersAuthenticateGeneralCallbackCreate({
    requestBody,
  }: {
    requestBody: V1AuthenticationCallbackRequestRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/authenticate/general-callback/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1Authenticate
   * @throws ApiError
   */
  public static v1UsersAuthenticateGuardianGeneralCreate({
    requestBody,
  }: {
    requestBody: V1AuthenticationRequestRequest,
  }): CancelablePromise<V1Authenticate> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/authenticate/guardian-general/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1UsersAuthenticateGuardianGeneralCallbackCreate({
    requestBody,
  }: {
    requestBody: V1AuthenticationCallbackRequestRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/authenticate/guardian-general-callback/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1Authenticate
   * @throws ApiError
   */
  public static v1UsersAuthenticateIpinCreate({
    requestBody,
  }: {
    requestBody: V1AuthenticationRequestRequest,
  }): CancelablePromise<V1Authenticate> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/authenticate/ipin/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1UsersAuthenticateIpinCallbackCreate({
    requestBody,
  }: {
    requestBody: V1AuthenticationCallbackRequestRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/authenticate/ipin-callback/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 이메일 중복 확인을 위한 API입니다.
   * @returns EmailDuplicateResponse
   * @throws ApiError
   */
  public static v1UsersEmailDuplicateCreate({
    requestBody,
  }: {
    requestBody: EmailDuplicateRequest,
  }): CancelablePromise<EmailDuplicateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/email-duplicate/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1UsersFacebookRetrieve(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/facebook/',
      errors: {
        302: `No response body`,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1UsersGithubRetrieve(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/github/',
      errors: {
        302: `No response body`,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1UsersGoogleRetrieve(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/google/',
      errors: {
        302: `No response body`,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1UsersKakaoRetrieve(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/kakao/',
      errors: {
        302: `No response body`,
      },
    });
  }

  /**
   * 토큰 발급을 위한 API입니다. Cookie에 access키의 값을 할당합니다.
   * @returns any No Response
   * @throws ApiError
   */
  public static v1UsersLoginCreate({
    requestBody,
  }: {
    requestBody: LoginRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/login/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1RetrieveOrganizationLandingPage
   * @throws ApiError
   */
  public static v1UsersOrganizationLandingPagesRetrieve({
    slug,
  }: {
    slug: string,
  }): CancelablePromise<V1RetrieveOrganizationLandingPage> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/organization-landing-pages/{slug}/',
      path: {
        'slug': slug,
      },
    });
  }

  /**
   * @returns any No Response
   * @throws ApiError
   */
  public static v1UsersOrganizationSignUpCreate({
    formData,
  }: {
    formData: V1OrganizationSignUpRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/organization-sign-up/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1UsersPasswordsChangePasswordCreate({
    requestBody,
  }: {
    requestBody: V1ChangePasswordRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/passwords/change-password/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns FindPassword
   * @throws ApiError
   */
  public static v1UsersPasswordsFindPasswordCreate({
    requestBody,
  }: {
    requestBody: FindPasswordRequest,
  }): CancelablePromise<FindPassword> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/passwords/find-password/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1UsersPasswordsResetPasswordCreate({
    requestBody,
  }: {
    requestBody: ResetPasswordRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/passwords/reset-password/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns ValidateResetPasswordToken
   * @throws ApiError
   */
  public static v1UsersPasswordsValidateTokenCreate({
    requestBody,
  }: {
    requestBody: ValidateResetPasswordTokenRequest,
  }): CancelablePromise<ValidateResetPasswordToken> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/passwords/validate-token/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1PersonalizationListApplicant
   * @throws ApiError
   */
  public static v1UsersPersonalizationsApplicantsList(): CancelablePromise<Array<V1PersonalizationListApplicant>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/personalizations/applicants/',
    });
  }

  /**
   * @returns DetailUser
   * @throws ApiError
   */
  public static v1UsersProfileRetrieve(): CancelablePromise<DetailUser> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/profile/',
    });
  }

  /**
   * @returns V1UpdateOrganizationUser
   * @throws ApiError
   */
  public static v1UsersProfilePartialUpdate({
    formData,
  }: {
    formData?: PatchedV1UpdateOrganizationUserRequest,
  }): CancelablePromise<V1UpdateOrganizationUser> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/users/profile/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns PaginatedV1ListProgrammersUserList
   * @throws ApiError
   */
  public static v1UsersProgrammersList({
    classification,
    expirationPeriod,
    acquisitionDate,
    languages,
    levels,
    page,
    pageSize,
  }: {
    /**
     * 시험 구분
     */
    classification: 'PCCE' | 'PCCP' | 'PCSQL',
    /**
     * 유효 기간입니다. 입력 한 유효 기간 이상인 인증서만 조회됩니다.
     */
    expirationPeriod: string,
    /**
     * 인증서 취득일입니다. 입력 한 인증서 취득일 이후 인증서만 조회됩니다.
     */
    acquisitionDate?: string,
    /**
     * 언어 목록
     */
    languages?: Array<'C' | 'C#' | 'C++' | 'Java' | 'JavaScript' | 'MySQL' | 'Oracle' | 'Python3'>,
    /**
     * 레벨 목록입니다. Max Level이 해당 레벨에 포함된 유저만 조회됩니다.
     */
    levels?: Array<1 | 2 | 3 | 4 | 5>,
    /**
     * A page number within the paginated result set.
     */
    page?: number,
    /**
     * Number of results to return per page.
     */
    pageSize?: number,
  }): CancelablePromise<PaginatedV1ListProgrammersUserList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/programmers/',
      query: {
        'acquisition_date': acquisitionDate,
        'classification': classification,
        'expiration_period': expirationPeriod,
        'languages': languages,
        'levels': levels,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @returns V1UpdateProgrammersUser
   * @throws ApiError
   */
  public static v1UsersProgrammersUpdate({
    programmersUserId,
    requestBody,
  }: {
    programmersUserId: number,
    requestBody: V1UpdateProgrammersUserRequest,
  }): CancelablePromise<V1UpdateProgrammersUser> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/users/programmers/{programmers_user_id}/',
      path: {
        'programmers_user_id': programmersUserId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns V1UpdateProgrammersUser
   * @throws ApiError
   */
  public static v1UsersProgrammersPartialUpdate({
    programmersUserId,
    requestBody,
  }: {
    programmersUserId: number,
    requestBody?: PatchedV1UpdateProgrammersUserRequest,
  }): CancelablePromise<V1UpdateProgrammersUser> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/users/programmers/{programmers_user_id}/',
      path: {
        'programmers_user_id': programmersUserId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1UsersProgrammersDestroy({
    programmersUserId,
  }: {
    programmersUserId: number,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/users/programmers/{programmers_user_id}/',
      path: {
        'programmers_user_id': programmersUserId,
      },
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public static v1UsersResendConfirmationCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/resend-confirmation/',
    });
  }

  /**
   * 회원 가입을 위한 API입니다. Cookie에 access키의 값을 할당합니다.
   * @returns any No Response
   * @throws ApiError
   */
  public static v1UsersSignUpCreate({
    requestBody,
  }: {
    requestBody: SignUpRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/sign-up/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static v1UsersSocialLoginRetrieve(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/social-login/',
      errors: {
        302: `No Response`,
      },
    });
  }

  /**
   * @returns ToggleUserMarketingAgreement
   * @throws ApiError
   */
  public static v1UsersToggleMarketingAgreementCreate({
    requestBody,
  }: {
    requestBody: ToggleUserMarketingAgreementRequest,
  }): CancelablePromise<ToggleUserMarketingAgreement> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/toggle/marketing-agreement/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 토큰을 제거하기 위한 API입니다. Cookie에 refresh키의 값을 검증합니다. 이후 해당 토큰을 이용할 수 없습니다.
   * @returns any No response body
   * @throws ApiError
   */
  public static v1UsersTokenLogoutCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/token/logout/',
    });
  }

  /**
   * Access 토큰을 재발급하기 위한 API입니다. Cookie에 refresh키의 값을 검증합니다.
   * @returns any No Response
   * @throws ApiError
   */
  public static v1UsersTokenRefreshCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/token/refresh/',
    });
  }

  /**
   * Access 토큰을 검증하기 위한 API입니다. Cookie에 access키의 값을 검증합니다.
   * @returns any No response body
   * @throws ApiError
   */
  public static v1UsersTokenVerifyCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users/token/verify/',
    });
  }

}
